// import React, { useState, useEffect, useRef } from 'react';
// import Header from '../../layouts/Header';
// import { Container, Spinner, Form } from 'react-bootstrap';
// import Select from 'react-select';
// import axiosInstance from '../../api/axios';
// import OutletSelect from '../../components/OutletSelect';
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';
// import XLSX from 'xlsx-js-style';
// import IntendImages from '../../assets/img/indentImg.png';

// /* ═══════════════════════════════════════════════════════════
//    CONFIG — everything backend-dependent lives here.
//    If a field/status name differs in the real response, fix it here only.
//    ═══════════════════════════════════════════════════════════ */
// const API = {
//     LIST: 'stock-indent',
//     UPDATE_STATUS: 'stock-indent/update-status',
//     STORAGE_LOCATIONS: 'storage-location',
//     UPDATE_FULFILLMENT: 'stock-indent/update-fullfillment-status', // PUT ?_id=... body { status }
// };
// const PAGE_SIZE = 30;

// // Item-level quantity accessors
// const qtyRequested = (it) => Number(it?.requestedQuantity || 0);
// // "qty taken by logistic user".
// // The list API has no dispatched field: logistics' picked qty comes back in totalReceivedQuantity
// // (receivedQuantity for the latest round) while the indent is still at Ready / Dispatched stage.
// // So: explicit field first, then — only at those stages — fall back to totalReceivedQuantity.
// const DISPATCH_STAGE = new Set(['READY', 'PARTIAL_READY', 'PARTIAL_DISPATCHED', 'DISPATCHED']);
// const qtyDispatched = (it, status) => {
//     const explicit = it?.dispatchedQuantity ?? it?.readyQuantity ?? it?.pickedQuantity;
//     if (explicit !== null && explicit !== undefined && explicit !== '') return Number(explicit);
//     if (DISPATCH_STAGE.has(normStatus(status))) return Number(it?.totalReceivedQuantity ?? it?.receivedQuantity ?? 0);
//     return 0;
// };
// const qtyReceived = (it) => Number(it?.totalReceivedQuantity || 0);

// // Column label for the logistics/dispatch quantity
// const READY_STAGE = new Set(['READY', 'PARTIAL_READY']);
// const dispatchLabel = (status) => (READY_STAGE.has(normStatus(status)) ? 'Ready to Pick' : 'Dispatched Qty');

// // Status lifecycle (paper flow):
// // Pending → Accepted/Rejected → Ready/Partial Ready → Dispatched/Partially Dispatched → Received/Partial Received → Closed
// const STATUS_CONFIG = {
//     PENDING: { label: 'Pending', color: '#d97706', bg: '#fef3c7', border: '#fcd34d' },
//     ACCEPTED: { label: 'Accepted', color: '#059669', bg: '#d1fae5', border: '#6ee7b7' },
//     REJECTED: { label: 'Rejected', color: '#dc2626', bg: '#fee2e2', border: '#fca5a5' },
//     READY: { label: 'Ready', color: '#0891b2', bg: '#cffafe', border: '#67e8f9' },
//     PARTIAL_READY: { label: 'Partial Ready', color: '#0d9488', bg: '#ccfbf1', border: '#5eead4' },
//     PARTIAL_DISPATCHED: { label: 'Partially Dispatched', color: '#7c3aed', bg: '#ede9fe', border: '#c4b5fd' },
//     DISPATCHED: { label: 'Dispatched', color: '#4f46e5', bg: '#e0e7ff', border: '#a5b4fc' },
//     PARTIAL_RECEIVED: { label: 'Partial Received', color: '#ea580c', bg: '#ffedd5', border: '#fdba74' },
//     RECEIVED: { label: 'Received', color: '#2563eb', bg: '#dbeafe', border: '#93c5fd' },
//     CLOSED: { label: 'Closed', color: '#374151', bg: '#f3f4f6', border: '#9ca3af' },
// };

// // Tolerates "PARTIAL-READY", "Partially Dispatched", "READY-TO-PICK" etc. from the API
// const STATUS_ALIASES = {
//     PARTIAL_DISPATCH: 'PARTIAL_DISPATCHED',
//     PARTIALLY_DISPATCH: 'PARTIAL_DISPATCHED',
//     PARTIALLY_DISPATCHED: 'PARTIAL_DISPATCHED',
//     DISPATCH: 'DISPATCHED',
//     PARTIALLY_READY: 'PARTIAL_READY',
//     PARTIALLY_RECEIVED: 'PARTIAL_RECEIVED',
//     READY_TO_PICK: 'READY',
// };
// const normStatus = (s) => {
//     const k = String(s || '').trim().toUpperCase().replace(/[\s-]+/g, '_');
//     return STATUS_ALIASES[k] || k;
// };

// // Which quantity columns make sense at each stage
// const SHOW_DISPATCHED = new Set(['READY', 'PARTIAL_READY', 'PARTIAL_DISPATCHED', 'DISPATCHED', 'PARTIAL_RECEIVED', 'RECEIVED', 'CLOSED']);
// const SHOW_RECEIVED = new Set(['PARTIAL_RECEIVED', 'RECEIVED', 'CLOSED']);

// // Admin can only act on these
// const ADMIN_ACTIONABLE = new Set(['PENDING', 'REJECTED']);

// // UI status key → value the API expects for update-fullfillment-status
// const API_STATUS = {
//     READY: 'READY',
//     PARTIAL_READY: 'PARTIALLY-READY',
//     DISPATCHED: 'DISPATCH',
//     PARTIAL_DISPATCHED: 'PARTIALLY-DISPATCH',
//     PARTIAL_RECEIVED: 'PARTIALLY-RECEIVED',
// };
// const toApiStatus = (k) => API_STATUS[k] || k;

// // Filter chips: one chip covers both the full and the partial status
// const CHIP_GROUPS = {
//     READY: ['READY', 'PARTIAL_READY'],
//     DISPATCHED: ['DISPATCHED', 'PARTIAL_DISPATCHED'],
//     RECEIVED: ['RECEIVED', 'PARTIAL_RECEIVED'],
// };
// const HIDDEN_CHIPS = new Set(['PARTIAL_READY', 'PARTIAL_DISPATCHED', 'PARTIAL_RECEIVED']);

// // Names the API uses in statusCounts, per UI status (they don't match the UI keys 1:1)
// const COUNT_KEYS = {
//     PENDING: ['pending'],
//     ACCEPTED: ['accepted'],
//     REJECTED: ['rejected'],
//     READY: ['ready'],
//     PARTIAL_READY: ['partiallyReady', 'partialReady'],
//     DISPATCHED: ['dispatch', 'dispatched'],
//     PARTIAL_DISPATCHED: ['partiallyDispatch', 'partiallyDispatched', 'partialDispatched'],
//     RECEIVED: ['received'],
//     PARTIAL_RECEIVED: ['partiallyReceived', 'partialReceived'],
//     CLOSED: ['closed'],
// };

// // Value sent to the LIST api for the status filter (backend returns full + partial for each)
// const FILTER_API_STATUS = {
//     READY: 'READY',
//     DISPATCHED: 'DISPATCH',
//     RECEIVED: 'RECEIVED',
// };
// const toFilterStatus = (k) => FILTER_API_STATUS[k] || k;

// // Fulfilment updates the admin can make: current status → statuses it can move to.
// // (Ready / Partial Ready are set by logistics, so Accepted has no admin fulfilment action.)
// const FULFILLMENT_TRANSITIONS = {
//     // READY: ['PARTIAL_DISPATCHED', 'DISPATCHED'],
//     READY: ['DISPATCHED'],  // only fully dispatch
//     // PARTIAL_READY: ['PARTIAL_DISPATCHED', 'DISPATCHED'],
//     PARTIAL_READY: ['PARTIAL_DISPATCHED'],   // only partially dispatch
//     PARTIAL_DISPATCHED: ['DISPATCHED'],
// };
// const FULFILLMENT_HINTS = {
//     PARTIAL_DISPATCHED: 'Only part of the quantity has been taken. It is deducted from the warehouse.',
//     DISPATCHED: 'The full quantity has been taken. It is deducted from the warehouse.',
// };

// const camel = (k) => k.toLowerCase().replace(/_([a-z])/g, (_, c) => c.toUpperCase());

// /* ─── formatters ─────────────────────────────────────────── */
// const fmt = (iso) =>
//     new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
// const formatDate = (iso) =>
//     new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

// const DATE_FILTER_OPTIONS = [
//     { key: 'TODAY', label: 'Today' },
//     { key: 'YESTERDAY', label: 'Yesterday' },
//     { key: 'LAST_7_DAYS', label: 'Last 7 Days' },
//     { key: 'LAST_30_DAYS', label: 'Last 30 Days' },
//     { key: 'LAST_MONTH', label: 'Last Month' },
//     { key: 'LAST_3_MONTHS', label: 'Last 3 Months' },
//     { key: 'CUSTOM', label: 'Custom Range' },
// ];

// // YYYY-MM-DD — used for both the API payload and <input type="date">
// const formatPayloadDate = (date) => {
//     if (!date) return '';
//     return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
// };

// const getDateRangeForOption = (key) => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
//     const start = new Date(today);
//     const end = new Date(today);
//     switch (key) {
//         case 'YESTERDAY': start.setDate(start.getDate() - 1); end.setDate(end.getDate() - 1); break;
//         case 'LAST_7_DAYS': start.setDate(start.getDate() - 6); break;
//         case 'LAST_30_DAYS': start.setDate(start.getDate() - 29); break;
//         case 'LAST_MONTH': {
//             const lastDayPrev = new Date(today.getFullYear(), today.getMonth(), 1);
//             lastDayPrev.setDate(0);
//             return { start: new Date(lastDayPrev.getFullYear(), lastDayPrev.getMonth(), 1), end: lastDayPrev };
//         }
//         case 'LAST_3_MONTHS': start.setMonth(start.getMonth() - 3); start.setDate(start.getDate() + 1); break;
//         default: break;
//     }
//     return { start, end };
// };

// const apiErrorMessage = (error, fallback = 'Failed to update. Please try again.') => {
//     const d = error?.response?.data;
//     const s = error?.response?.status;
//     let msg = '';
//     if (s === 406) msg = d?.error?.message || d?.error;
//     else if (s === 412) msg = d?.data?.message || d?.error;
//     else msg = d?.message || d?.error?.message || d?.error;
//     return (typeof msg === 'string' && msg) || fallback;
// };

// const getWarehouseName = (req) =>
//     req?.storageLocation && typeof req.storageLocation === 'object' ? req.storageLocation.name : '';

// /* ═══════════════════════════════════════════════════════════
//    DOWNLOADS (single indent)
//    ═══════════════════════════════════════════════════════════ */
// const sortItems = (items) =>
//     [...items].sort((a, b) => {
//         const c = (a.rawMaterial?.mainCategoryName || '').localeCompare(b.rawMaterial?.mainCategoryName || '');
//         return c !== 0 ? c : (a.rawMaterial?.subCategoryName || '').localeCompare(b.rawMaterial?.subCategoryName || '');
//     });

// const handleDownloadPDF = (request) => {
//     const doc = new jsPDF('p', 'mm', 'a4');
//     const pageWidth = doc.internal.pageSize.getWidth();
//     const primary = [9, 165, 247];
//     const status = normStatus(request.status || 'PENDING');
//     const showDisp = SHOW_DISPATCHED.has(status);
//     const showRec = SHOW_RECEIVED.has(status);

//     doc.setFillColor(...primary);
//     doc.rect(0, 0, pageWidth, 28, 'F');
//     try { doc.addImage(IntendImages, 'PNG', 10, 4, 50, 20); } catch (e) { /* logo optional */ }
//     doc.setTextColor(255, 255, 255);
//     doc.setFont('helvetica', 'bold'); doc.setFontSize(15);
//     doc.text('STOCK REQUEST', pageWidth - 14, 13, { align: 'right' });
//     doc.setFontSize(8); doc.setFont('helvetica', 'normal');
//     doc.text(`${request.indentNumber || ''}`, pageWidth - 14, 20, { align: 'right' });
//     doc.setTextColor(40, 40, 40);

//     const y = 36;
//     const pair = (label, value, lx, vx, yy) => {
//         doc.setFont('helvetica', 'normal'); doc.text(label, lx, yy);
//         doc.setFont('helvetica', 'bold'); doc.text(String(value), vx, yy);
//     };
//     doc.setFontSize(8.5);
//     pair('Indent :', request.indentNumber || '-', 14, 38, y);
//     pair('Status :', STATUS_CONFIG[status]?.label || status, 14, 38, y + 6);
//     pair('Date :', formatDate(request.createdAt), 14, 38, y + 12);
//     pair('Fin. Year :', request.fin_year || '-', 14, 38, y + 18);
//     pair('Outlet :', request?.outlet?.name || '-', 110, 128, y);
//     pair('City :', request?.outlet?.city || '-', 110, 128, y + 6);
//     pair('Warehouse :', getWarehouseName(request) || '-', 110, 128, y + 12);

//     const dividerY = y + 26;
//     doc.setDrawColor(200, 200, 200);
//     doc.line(14, dividerY, pageWidth - 14, dividerY);

//     const items = sortItems(request.items || []);
//     const head = [['Sr No', 'Material', 'Main Cat', 'Sub Cat', 'Unit', 'Req Qty']];
//     // if (showDisp) head[0].push('Disp Qty');
//     if (showDisp) head[0].push(dispatchLabel(status));
//     if (showRec) head[0].push('Rec Qty', 'Balance');

//     let tReq = 0, tDisp = 0, tRec = 0;
//     const body = items.map((it, i) => {
//         const rm = it.rawMaterial || {};
//         const r = qtyRequested(it), d = qtyDispatched(it, status), c = qtyReceived(it);
//         tReq += r; tDisp += d; tRec += c;
//         const row = [i + 1, rm.name || '-', rm.mainCategoryName || '-', rm.subCategoryName || '-', rm.unit || '-', r.toFixed(2)];
//         if (showDisp) row.push(d.toFixed(2));
//         if (showRec) row.push(c.toFixed(2), (r - c).toFixed(2));
//         return row;
//     });

//     const columnStyles = { 0: { halign: 'center', cellWidth: 10 }, 1: { halign: 'left' } };
//     for (let i = 2; i < head[0].length; i++) columnStyles[i] = { halign: 'center' };

//     autoTable(doc, {
//         startY: dividerY + 6, head, body, theme: 'grid',
//         headStyles: { fillColor: primary, textColor: 255, fontStyle: 'bold', halign: 'center', fontSize: 8 },
//         styles: { fontSize: 8, cellPadding: 2.5, font: 'helvetica', valign: 'middle' },
//         alternateRowStyles: { fillColor: [245, 250, 255] },
//         columnStyles,
//     });

//     const finalY = doc.lastAutoTable.finalY + 8;
//     doc.setFontSize(8.5); doc.setFont('helvetica', 'bold');
//     let totals = `Total Items: ${items.length}   |   Requested: ${tReq.toFixed(2)}`;
//     // if (showDisp) totals += `   |   Dispatched: ${tDisp.toFixed(2)}`;
//     if (showDisp) totals += `   |   ${dispatchLabel(status).replace(' Qty', '')}: ${tDisp.toFixed(2)}`;
//     if (showRec) totals += `   |   Received: ${tRec.toFixed(2)}   |   Balance: ${(tReq - tRec).toFixed(2)}`;
//     doc.text(totals, pageWidth - 14, finalY, { align: 'right' });

//     doc.setFont('helvetica', 'normal');
//     doc.text('Authorized Signature', pageWidth - 60, finalY + 18);
//     doc.line(pageWidth - 60, finalY + 20, pageWidth - 14, finalY + 20);
//     doc.setFontSize(7); doc.setTextColor(100, 100, 100);
//     doc.text(`Generated on ${new Date().toLocaleString('en-IN')}`, 14, doc.internal.pageSize.getHeight() - 10);
//     doc.save(`Stock-Request-${request.indentNumber || 'Details'}.pdf`);
// };

// const XL = { PRIMARY: '09A5F7', WHITE: 'FFFFFF', DARK: '1F2937', MUTED: '6B7280', ALT: 'F0F7FF', TOTAL: 'EEF2FF', INDIGO: '4F46E5', GREEN: '059669', RED: 'DC2626' };
// const xlBorder = (color = 'D1D5DB') => {
//     const e = { style: 'thin', color: { rgb: color } };
//     return { top: e, bottom: e, left: e, right: e };
// };
// const xlCell = (v, o = {}) => ({
//     v, t: typeof v === 'number' ? 'n' : 's',
//     ...(typeof v === 'number' ? { z: '#,##0.00' } : {}),
//     s: {
//         font: { name: 'Arial', sz: o.sz || 10, bold: !!o.bold, color: { rgb: o.color || XL.DARK } },
//         ...(o.bg ? { fill: { fgColor: { rgb: o.bg } } } : {}),
//         alignment: { horizontal: o.align || 'left', vertical: 'center', wrapText: true },
//         ...(o.noBorder ? {} : { border: xlBorder(o.borderColor) }),
//     },
// });

// const handleDownloadExcel = (request) => {
//     const status = normStatus(request.status || 'PENDING');
//     const showDisp = SHOW_DISPATCHED.has(status);
//     const showRec = SHOW_RECEIVED.has(status);
//     const headers = ['Sr No', 'Material', 'Main Category', 'Sub Category', 'HSN', 'Unit', 'Req Qty'];
//     // if (showDisp) headers.push('Disp Qty');
//     if (showDisp) headers.push(dispatchLabel(status));
//     if (showRec) headers.push('Rec Qty', 'Balance');
//     const last = headers.length - 1;
//     const ws = { '!merges': [] };
//     const put = (r, c, cell) => { ws[XLSX.utils.encode_cell({ r, c })] = cell; };
//     const merge = (r, c1, c2) => ws['!merges'].push({ s: { r, c: c1 }, e: { r, c: c2 } });
//     const banner = (r, text, o) => {
//         for (let c = 0; c <= last; c++) put(r, c, xlCell(c === 0 ? text : '', { ...o, bg: XL.PRIMARY, color: XL.WHITE, align: 'center', noBorder: true }));
//         merge(r, 0, last);
//     };

//     banner(0, 'STOCK REQUEST', { sz: 16, bold: true });
//     banner(1, request.indentNumber || '', { sz: 9 });

//     const left = [['Indent Number', request.indentNumber || '-'], ['Status', STATUS_CONFIG[status]?.label || status], ['Date', formatDate(request.createdAt)], ['Financial Year', request.fin_year || '-']];
//     const right = [['Outlet', request?.outlet?.name || '-'], ['City', request?.outlet?.city || '-'], ['Warehouse', getWarehouseName(request) || '-'], ['', '']];
//     left.forEach(([l, v], i) => {
//         const r = 3 + i;
//         put(r, 0, xlCell(l, { bold: true, color: XL.MUTED, bg: 'F9FAFB', sz: 9 }));
//         for (let c = 1; c <= 3; c++) put(r, c, xlCell(c === 1 ? v : '', { bold: true, bg: 'F9FAFB', sz: 9 }));
//         merge(r, 1, 3);
//         put(r, 4, xlCell(right[i][0], { bold: true, color: XL.MUTED, bg: 'F9FAFB', sz: 9 }));
//         for (let c = 5; c <= last; c++) put(r, c, xlCell(c === 5 ? right[i][1] : '', { bold: true, bg: 'F9FAFB', sz: 9 }));
//         merge(r, 5, last);
//     });

//     headers.forEach((h, c) => put(8, c, xlCell(h, { bold: true, color: XL.WHITE, bg: XL.PRIMARY, align: 'center', borderColor: XL.PRIMARY })));

//     let tReq = 0, tDisp = 0, tRec = 0;
//     sortItems(request.items || []).forEach((it, idx) => {
//         const rm = it.rawMaterial || {};
//         const r = qtyRequested(it), d = qtyDispatched(it, status), c = qtyReceived(it);
//         tReq += r; tDisp += d; tRec += c;
//         const row = 9 + idx;
//         const o = { bg: idx % 2 ? XL.ALT : XL.WHITE };
//         const cells = [
//             xlCell(idx + 1, { ...o, align: 'center' }), xlCell(rm.name || '-', o),
//             xlCell(rm.mainCategoryName || '-', { ...o, align: 'center' }), xlCell(rm.subCategoryName || '-', { ...o, align: 'center' }),
//             xlCell(rm.hsn || '-', { ...o, align: 'center' }), xlCell(rm.unit || '-', { ...o, align: 'center' }),
//             xlCell(r, { ...o, align: 'center', bold: true, color: XL.INDIGO }),
//         ];
//         if (showDisp) cells.push(xlCell(d, { ...o, align: 'center', bold: true, color: '7C3AED' }));
//         if (showRec) cells.push(xlCell(c, { ...o, align: 'center', bold: true, color: XL.GREEN }), xlCell(r - c, { ...o, align: 'center', bold: true, color: r - c > 0 ? XL.RED : XL.GREEN }));
//         cells.forEach((cell, ci) => put(row, ci, cell));
//     });

//     const tr = 9 + (request.items || []).length;
//     const tot = (v, a = 'center', color = XL.INDIGO) => xlCell(v, { bold: true, sz: 11, bg: XL.TOTAL, align: a, color, borderColor: 'C4B5FD' });
//     const totals = [tot(''), tot(''), tot(''), tot(''), tot(''), tot('TOTAL', 'right', XL.DARK), tot(tReq)];
//     if (showDisp) totals.push(tot(tDisp, 'center', '7C3AED'));
//     if (showRec) totals.push(tot(tRec, 'center', XL.GREEN), tot(tReq - tRec, 'center', XL.RED));
//     totals.forEach((cell, c) => put(tr, c, cell));

//     put(tr + 2, 0, xlCell(`Generated on ${new Date().toLocaleString('en-IN')}`, { sz: 8, color: XL.MUTED, noBorder: true }));
//     merge(tr + 2, 0, last);

//     ws['!cols'] = [{ wch: 7 }, { wch: 30 }, { wch: 18 }, { wch: 18 }, { wch: 12 }, { wch: 10 }, ...Array(headers.length - 6).fill({ wch: 13 })];
//     ws['!rows'] = [{ hpt: 30 }, { hpt: 18 }, { hpt: 6 }, { hpt: 18 }, { hpt: 18 }, { hpt: 18 }, { hpt: 18 }, { hpt: 6 }, { hpt: 22 }];
//     ws['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: tr + 2, c: last } });

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Stock Request');
//     XLSX.writeFile(wb, `Stock-Request-${request.indentNumber || 'Details'}.xlsx`);
// };

// /* ═══════════════════════════════════════════════════════════
//    SMALL UI PIECES
//    ═══════════════════════════════════════════════════════════ */
// const useClickOutside = (ref, onOutside) => {
//     useEffect(() => {
//         const h = (e) => { if (ref.current && !ref.current.contains(e.target)) onOutside(); };
//         document.addEventListener('mousedown', h);
//         return () => document.removeEventListener('mousedown', h);
//     }, []); // eslint-disable-line react-hooks/exhaustive-deps
// };

// const DownloadDropdown = ({ onPDF, onExcel, label = '📄 Download', isDark }) => {
//     const [open, setOpen] = useState(false);
//     const ref = useRef(null);
//     useClickOutside(ref, () => setOpen(false));

//     const itemStyle = (last) => ({
//         display: 'flex', alignItems: 'center', gap: 8, width: '100%', background: 'none', border: 'none',
//         padding: '9px 14px', fontSize: 13, fontWeight: 600, color: isDark ? '#f3f4f6' : '#374151',
//         cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
//         borderBottom: last ? 'none' : `1px solid ${isDark ? '#2d3748' : '#f3f4f6'}`,
//     });

//     return (
//         <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
//             <button onClick={() => setOpen(o => !o)} style={{
//                 background: '#fef3c7', border: '1px solid #fcd34d', borderRadius: 7, padding: '6px 13px',
//                 fontSize: 12, fontWeight: 700, color: '#d97706', cursor: 'pointer', whiteSpace: 'nowrap',
//                 display: 'flex', alignItems: 'center', gap: 5, fontFamily: 'inherit',
//             }}
//                 onMouseEnter={e => e.currentTarget.style.background = '#fde68a'}
//                 onMouseLeave={e => e.currentTarget.style.background = '#fef3c7'}
//             >
//                 {label}
//                 <span style={{ fontSize: 9, display: 'inline-block', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}>▼</span>
//             </button>
//             {open && (
//                 <div style={{
//                     position: 'absolute', right: 0, top: 'calc(100% + 4px)', background: isDark ? '#1e293b' : '#fff',
//                     border: `1px solid ${isDark ? '#2d3748' : '#e5e7eb'}`, borderRadius: 8,
//                     boxShadow: '0 8px 24px rgba(0,0,0,0.12)', minWidth: 150, zIndex: 200, overflow: 'hidden',
//                 }}>
//                     <button onClick={() => { onPDF(); setOpen(false); }} style={itemStyle(false)}><span>📄</span> Download PDF</button>
//                     <button onClick={() => { onExcel(); setOpen(false); }} style={itemStyle(true)}><span>📊</span> Download Excel</button>
//                 </div>
//             )}
//         </div>
//     );
// };

// const DateRangeDropdown = ({ dateFilterKey, startDate, endDate, onPresetSelect, onCustomDateChange, isDark }) => {
//     const [open, setOpen] = useState(false);
//     const ref = useRef(null);
//     useClickOutside(ref, () => setOpen(false));

//     const borderCol = isDark ? '#2d3748' : '#e5e7eb';
//     const textMain = isDark ? '#f3f4f6' : '#111827';
//     const textMuted = isDark ? '#9ca3af' : '#6b7280';
//     const selectedLabel = DATE_FILTER_OPTIONS.find(o => o.key === dateFilterKey)?.label || 'Select Range';
//     const dateInput = { flex: 1, background: isDark ? '#252d3d' : '#fff', border: `1px solid ${borderCol}`, borderRadius: 6, padding: '6px 8px', fontSize: 12, color: textMain, fontFamily: 'inherit', outline: 'none' };

//     return (
//         <div ref={ref} style={{ position: 'relative' }}>
//             <Form.Label style={{ color: textMuted, marginBottom: 6, fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
//                 <i className="bi bi-calendar-range me-2"></i>Date Range
//             </Form.Label>
//             <button type="button" onClick={() => setOpen(o => !o)} style={{
//                 width: '100%', textAlign: 'left', background: isDark ? '#252d3d' : '#f9fafb', border: `1px solid ${borderCol}`,
//                 borderRadius: 8, padding: '8px 12px', fontSize: 13, color: textMain, fontFamily: 'inherit', cursor: 'pointer',
//                 display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//             }}>
//                 <span>
//                     {selectedLabel}
//                     {dateFilterKey === 'CUSTOM' && startDate && endDate && (
//                         <span style={{ color: textMuted, marginLeft: 6, fontSize: 11 }}>({formatPayloadDate(startDate)} – {formatPayloadDate(endDate)})</span>
//                     )}
//                 </span>
//                 <span style={{ fontSize: 9, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}>▼</span>
//             </button>

//             {open && (
//                 <div style={{
//                     position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, minWidth: 260,
//                     background: isDark ? '#1e293b' : '#fff', border: `1px solid ${borderCol}`, borderRadius: 8,
//                     boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 300, overflow: 'hidden',
//                 }}>
//                     {DATE_FILTER_OPTIONS.filter(o => o.key !== 'CUSTOM').map(opt => (
//                         <button type="button" key={opt.key} onClick={() => { onPresetSelect(opt.key); setOpen(false); }} style={{
//                             display: 'block', width: '100%', textAlign: 'left', border: 'none', padding: '9px 14px', fontSize: 13, fontWeight: 600,
//                             background: dateFilterKey === opt.key ? (isDark ? '#252d3d' : '#eef2ff') : 'transparent',
//                             color: dateFilterKey === opt.key ? '#6366f1' : textMain, cursor: 'pointer', fontFamily: 'inherit',
//                             borderBottom: `1px solid ${isDark ? '#2d3748' : '#f3f4f6'}`,
//                         }}>{opt.label}</button>
//                     ))}
//                     <div style={{ padding: '10px 14px', background: isDark ? '#1a2132' : '#fafafa' }}>
//                         <div style={{ fontSize: 12, fontWeight: 700, color: textMuted, marginBottom: 8 }}>Custom Range</div>
//                         <div style={{ display: 'flex', gap: 8 }}>
//                             <input type="date" value={formatPayloadDate(startDate)} max={formatPayloadDate(endDate) || formatPayloadDate(new Date())}
//                                 onChange={(e) => onCustomDateChange('start', e.target.value)} style={dateInput} />
//                             <input type="date" value={formatPayloadDate(endDate)} min={formatPayloadDate(startDate)} max={formatPayloadDate(new Date())}
//                                 onChange={(e) => onCustomDateChange('end', e.target.value)} style={dateInput} />
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// const StatusPill = ({ status }) => {
//     const key = normStatus(status);
//     const cfg = STATUS_CONFIG[key] || { label: status, color: '#6b7280', bg: '#f3f4f6', border: '#d1d5db' };
//     return (
//         <span style={{
//             padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, letterSpacing: '0.04em',
//             textTransform: 'uppercase', color: cfg.color, background: cfg.bg, border: `1px solid ${cfg.border}`, whiteSpace: 'nowrap',
//         }}>{cfg.label}</span>
//     );
// };

// const ItemsRow = ({ items, status }) => {
//     const [open, setOpen] = useState(false);
//     const key = normStatus(status);
//     const showDisp = SHOW_DISPATCHED.has(key);
//     const showRec = SHOW_RECEIVED.has(key);
//     const cols = `2.5fr 1fr 1fr 1fr 130px${showDisp ? ' 130px' : ''}${showRec ? ' 130px 130px' : ''}`;
//     const qtyCell = (v, unit, color) => (
//         <span style={{ textAlign: 'left', fontWeight: 700, color, fontSize: 14 }}>
//             {v.toFixed(2)} <span style={{ fontSize: 12, fontWeight: 500 }}>{unit}</span>
//         </span>
//     );

//     return (
//         <div style={{ marginTop: 10 }}>
//             <button onClick={() => setOpen(o => !o)} style={{
//                 background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'inline-flex',
//                 alignItems: 'center', gap: 6, color: '#6366f1', fontSize: 13, fontWeight: 600,
//             }}>
//                 <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 20, height: 20, borderRadius: 6, background: '#eef2ff', color: '#6366f1', fontSize: 11, fontWeight: 800 }}>{items.length}</span>
//                 Item{items.length !== 1 ? 's' : ''}
//                 <span style={{ fontSize: 9, display: 'inline-block', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}>▼</span>
//             </button>

//             {open && (
//                 <div style={{ marginTop: 8, border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
//                     <div style={{ display: 'grid', gridTemplateColumns: cols, background: '#f9fafb', padding: '7px 14px', borderBottom: '1px solid #e5e7eb', fontSize: 11, fontWeight: 700, color: '#6b7280', letterSpacing: '0.05em', textTransform: 'uppercase' }}>
//                         <span>Material</span><span>Category</span><span>HSN</span><span>Unit</span>
//                         <span>Requested Qty</span>
//                         {/* {showDisp && <span>Dispatched Qty</span>} */}
//                         {showDisp && <span>{dispatchLabel(key)}</span>}
//                         {showRec && <span>Received Qty</span>}
//                         {showRec && <span>Balance Qty</span>}
//                     </div>
//                     {items.map((item, idx) => {
//                         const rm = item.rawMaterial || {};
//                         const r = qtyRequested(item), d = qtyDispatched(item, key), c = qtyReceived(item);
//                         return (
//                             <div key={item._id || idx} style={{
//                                 display: 'grid', gridTemplateColumns: cols, padding: '9px 14px', alignItems: 'center', fontSize: 13,
//                                 background: idx % 2 === 0 ? '#fff' : '#fafafa', borderBottom: idx < items.length - 1 ? '1px solid #f3f4f6' : 'none',
//                             }}>
//                                 <div>
//                                     <div style={{ fontWeight: 600, color: '#111827' }}>{rm.name || '—'}</div>
//                                     {rm.description && <div style={{ color: '#9ca3af', fontSize: 11, marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>{rm.description}</div>}
//                                 </div>
//                                 <span style={{ color: '#373b41', fontSize: 12 }}>
//                                     {rm.subCategoryName}
//                                     <div style={{ color: '#6b7280', fontSize: 12 }}>{rm.mainCategoryName || '—'}</div>
//                                 </span>
//                                 <span style={{ color: '#6b7280', fontFamily: 'monospace', fontSize: 12 }}>{rm.hsn || '—'}</span>
//                                 <span style={{ color: '#6b7280', fontSize: 12 }}>{rm.unit || '—'}</span>
//                                 {qtyCell(r, rm.unit, '#6366f1')}
//                                 {showDisp && qtyCell(d, rm.unit, '#7c3aed')}
//                                 {showRec && qtyCell(c, rm.unit, '#059669')}
//                                 {showRec && qtyCell(r - c, rm.unit, r - c > 0 ? '#dc2626' : '#059669')}
//                             </div>
//                         );
//                     })}
//                 </div>
//             )}
//         </div>
//     );
// };

// /* ─── Modal shell (shared by Accept/Reject modal) ─────────── */
// const ModalShell = ({ title, onHide, children, footer }) => (
//     <div style={{ position: 'fixed', inset: 0, zIndex: 1050, background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onHide}>
//         <div style={{ background: '#fff', borderRadius: 14, width: '100%', maxWidth: 440, margin: '0 16px', boxShadow: '0 20px 60px rgba(0,0,0,0.18)' }} onClick={e => e.stopPropagation()}>
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #f3f4f6' }}>
//                 <span style={{ fontWeight: 800, fontSize: 16, color: '#111827' }}>{title}</span>
//                 <button onClick={onHide} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 22, color: '#9ca3af', lineHeight: 1, padding: 0 }}>×</button>
//             </div>
//             <div style={{ padding: 20 }}>{children}</div>
//             <div style={{ padding: '12px 20px', borderTop: '1px solid #f3f4f6', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>{footer}</div>
//         </div>
//     </div>
// );

// /* ─── Accept / Reject modal ───────────────────────────────── */
// // ACCEPTED → warehouse (storageLocation) mandatory. REJECTED → not sent.
// // A REJECTED indent can only be accepted again.
// const AcceptRejectModal = ({ request, onHide, onUpdated, accessToken }) => {
//     const wasRejected = normStatus(request.status) === 'REJECTED';
//     const [status, setStatus] = useState('ACCEPTED');
//     const [saving, setSaving] = useState(false);
//     const [error, setError] = useState('');
//     const [locations, setLocations] = useState([]);
//     const [loadingLocations, setLoadingLocations] = useState(false);
//     const [selectedLocation, setSelectedLocation] = useState(null);
//     const defaultApplied = useRef(false);

//     const options = wasRejected ? ['ACCEPTED'] : ['ACCEPTED', 'REJECTED'];
//     const headers = { Authorization: `Bearer ${accessToken}` };

//     useEffect(() => {
//         (async () => {
//             setLoadingLocations(true);
//             try {
//                 const res = await axiosInstance.get(API.STORAGE_LOCATIONS, { headers });
//                 setLocations(res?.data?.data?.storageLocations || []);
//             } catch (e) { /* select just shows no options */ }
//             finally { setLoadingLocations(false); }
//         })();
//     }, [accessToken]); // eslint-disable-line react-hooks/exhaustive-deps

//     const locationOptions = locations.map(l => ({ value: l._id, label: l.name, sublabel: l.city }));

//     // Preselect the outlet's default warehouse (user can still change it)
//     useEffect(() => {
//         if (defaultApplied.current || !locationOptions.length) return;
//         const id = request?.outlet?.storageLocation?._id || request?.outlet?.storageLocation;
//         const match = id && locationOptions.find(o => String(o.value) === String(id));
//         if (match) { setSelectedLocation(match); defaultApplied.current = true; }
//     }, [locations, request]); // eslint-disable-line react-hooks/exhaustive-deps

//     const selectStyles = {
//         control: (b, s) => ({ ...b, background: '#fff', borderColor: s.isFocused ? '#6366f1' : '#e5e7eb', borderWidth: 1.5, borderRadius: 9, minHeight: 42, boxShadow: s.isFocused ? '0 0 0 3px rgba(99,102,241,0.15)' : 'none', '&:hover': { borderColor: '#6366f1' }, fontSize: 13, fontWeight: 600 }),
//         menu: (b) => ({ ...b, borderRadius: 10, zIndex: 9999 }),
//         menuPortal: (b) => ({ ...b, zIndex: 9999 }),
//         option: (b, s) => ({ ...b, background: s.isSelected ? '#6366f1' : s.isFocused ? '#eef2ff' : 'transparent', color: s.isSelected ? '#fff' : '#111827', fontSize: 13, padding: '10px 14px', cursor: 'pointer' }),
//         indicatorSeparator: () => ({ display: 'none' }),
//     };

//     const handleSave = async () => {
//         if (status === 'ACCEPTED' && !selectedLocation) {
//             setError('Please select a warehouse before accepting.');
//             return;
//         }
//         setSaving(true); setError('');
//         try {
//             const payload = { _id: request._id, status };
//             if (status === 'ACCEPTED') payload.storageLocation = selectedLocation.value;
//             await axiosInstance.put(API.UPDATE_STATUS, payload, { headers });
//             onUpdated();
//             onHide();
//         } catch (err) {
//             setError(apiErrorMessage(err));
//         } finally {
//             setSaving(false);
//         }
//     };

//     const blocked = saving || (status === 'ACCEPTED' && !selectedLocation);

//     return (
//         <ModalShell
//             title={wasRejected ? 'Accept Stock Request' : 'Accept / Reject Stock Request'}
//             onHide={onHide}
//             footer={<>
//                 <button onClick={onHide} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 18px', fontSize: 13, fontWeight: 600, color: '#374151', cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
//                 <button onClick={handleSave} disabled={blocked} style={{ background: blocked ? '#a5b4fc' : '#6366f1', border: 'none', borderRadius: 8, padding: '8px 22px', fontSize: 13, fontWeight: 700, color: '#fff', cursor: blocked ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 7, fontFamily: 'inherit' }}>
//                     {saving ? <><Spinner animation="border" size="sm" /> Saving…</> : 'Save Changes'}
//                 </button>
//             </>}
//         >
//             <div style={{ marginBottom: 16, padding: '10px 14px', background: '#f9fafb', borderRadius: 8, border: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <div>
//                     <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, marginBottom: 3, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Indent Number</div>
//                     <div style={{ fontWeight: 700, color: '#6366f1', fontFamily: 'monospace', fontSize: 14 }}>{request.indentNumber}</div>
//                 </div>
//                 <div style={{ textAlign: 'right' }}>
//                     <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Current Status</div>
//                     <StatusPill status={request.status} />
//                 </div>
//             </div>

//             {wasRejected && (
//                 <div style={{ marginBottom: 14, padding: '10px 14px', borderRadius: 8, background: '#f9fafb', border: '1px solid #e5e7eb', color: '#6b7280', fontSize: 13 }}>
//                     This request was rejected. You can accept it again.
//                 </div>
//             )}

//             <div style={{ marginBottom: 8, fontSize: 13, fontWeight: 700, color: '#374151' }}>
//                 Set Status {!wasRejected && <span style={{ fontWeight: 400, color: '#9ca3af', fontSize: 12 }}>(choose one)</span>}
//             </div>
//             <div style={{ display: 'flex', gap: 10 }}>
//                 {options.map(key => {
//                     const cfg = STATUS_CONFIG[key];
//                     return (
//                         <label key={key} style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '12px 14px', borderRadius: 10, cursor: 'pointer', border: `2px solid ${status === key ? cfg.border : '#e5e7eb'}`, background: status === key ? cfg.bg : '#fff', transition: 'all .15s' }}>
//                             <input type="radio" name="status" value={key} checked={status === key} onChange={() => { setStatus(key); setError(''); }} style={{ accentColor: cfg.color, width: 15, height: 15 }} />
//                             <span style={{ fontWeight: 700, fontSize: 13, color: cfg.color }}>{cfg.label}</span>
//                         </label>
//                     );
//                 })}
//             </div>

//             {status === 'ACCEPTED' && (
//                 <div style={{ marginTop: 16 }}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
//                         <span style={{ fontSize: 13, fontWeight: 700, color: '#374151' }}>Warehouse</span>
//                         <span style={{ fontSize: 10, color: '#ef4444', fontWeight: 700, background: '#fee2e2', padding: '2px 6px', borderRadius: 5 }}>REQUIRED</span>
//                     </div>
//                     <Select
//                         options={locationOptions}
//                         value={selectedLocation}
//                         onChange={setSelectedLocation}
//                         formatOptionLabel={({ label, sublabel }) => (
//                             <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//                                 <span style={{ fontWeight: 700, fontSize: 13 }}>{label}</span>
//                                 {sublabel && <span style={{ fontSize: 11, color: '#6b7280' }}>📍 {sublabel}</span>}
//                             </div>
//                         )}
//                         placeholder={loadingLocations ? 'Loading warehouses…' : 'Select warehouse…'}
//                         isLoading={loadingLocations}
//                         styles={selectStyles}
//                         isClearable
//                         noOptionsMessage={() => 'No warehouses found'}
//                         menuPortalTarget={document.body}
//                         menuPosition="fixed"
//                     />
//                     <div style={{ marginTop: 8, fontSize: 12, color: '#6b7280' }}>Logistics will see this indent under the selected warehouse.</div>
//                 </div>
//             )}

//             {error && <div style={{ marginTop: 12, padding: '10px 14px', background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 8, color: '#dc2626', fontSize: 13 }}>{error}</div>}
//         </ModalShell>
//     );
// };

// /* ─── Fulfilment status modal (Ready / Partially Ready / Partially Dispatched) ─── */
// const FulfillmentModal = ({ request, onHide, onUpdated, accessToken }) => {
//     const options = FULFILLMENT_TRANSITIONS[normStatus(request.status)] || [];
//     const [status, setStatus] = useState(options[0]);
//     const [saving, setSaving] = useState(false);
//     const [error, setError] = useState('');

//     const handleSave = async () => {
//         setSaving(true); setError('');
//         try {
//             await axiosInstance.put(
//                 API.UPDATE_FULFILLMENT,
//                 { status: toApiStatus(status) },
//                 { params: { _id: request._id }, headers: { Authorization: `Bearer ${accessToken}` } }
//             );
//             onUpdated();
//             onHide();
//         } catch (err) {
//             setError(apiErrorMessage(err));
//         } finally {
//             setSaving(false);
//         }
//     };

//     return (
//         <ModalShell
//             title="Update Indent Status"
//             onHide={onHide}
//             footer={<>
//                 <button onClick={onHide} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 18px', fontSize: 13, fontWeight: 600, color: '#374151', cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
//                 <button onClick={handleSave} disabled={saving || !status} style={{ background: saving ? '#a5b4fc' : '#6366f1', border: 'none', borderRadius: 8, padding: '8px 22px', fontSize: 13, fontWeight: 700, color: '#fff', cursor: saving ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 7, fontFamily: 'inherit' }}>
//                     {saving ? <><Spinner animation="border" size="sm" /> Saving…</> : 'Update Status'}
//                 </button>
//             </>}
//         >
//             <div style={{ marginBottom: 16, padding: '10px 14px', background: '#f9fafb', borderRadius: 8, border: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <div>
//                     <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, marginBottom: 3, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Indent Number</div>
//                     <div style={{ fontWeight: 700, color: '#6366f1', fontFamily: 'monospace', fontSize: 14 }}>{request.indentNumber}</div>
//                 </div>
//                 <div style={{ textAlign: 'right' }}>
//                     <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Current Status</div>
//                     <StatusPill status={request.status} />
//                 </div>
//             </div>

//             <div style={{ marginBottom: 8, fontSize: 13, fontWeight: 700, color: '#374151' }}>
//                 Move to <span style={{ fontWeight: 400, color: '#9ca3af', fontSize: 12 }}>(choose one)</span>
//             </div>
//             <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
//                 {options.map(key => {
//                     const cfg = STATUS_CONFIG[key];
//                     const active = status === key;
//                     return (
//                         <label key={key} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '11px 14px', borderRadius: 10, cursor: 'pointer', border: `2px solid ${active ? cfg.border : '#e5e7eb'}`, background: active ? cfg.bg : '#fff', transition: 'all .15s' }}>
//                             <input type="radio" name="fulfilment" value={key} checked={active} onChange={() => { setStatus(key); setError(''); }} style={{ accentColor: cfg.color, width: 15, height: 15, marginTop: 2 }} />
//                             <span>
//                                 <span style={{ display: 'block', fontWeight: 700, fontSize: 13, color: cfg.color }}>{cfg.label}</span>
//                                 <span style={{ display: 'block', fontSize: 12, color: '#6b7280', marginTop: 2 }}>{FULFILLMENT_HINTS[key]}</span>
//                             </span>
//                         </label>
//                     );
//                 })}
//             </div>

//             {error && <div style={{ marginTop: 12, padding: '10px 14px', background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 8, color: '#dc2626', fontSize: 13 }}>{error}</div>}
//         </ModalShell>
//     );
// };

// /* ─── Request Card ───────────────────────────────────────── */
// const RequestCard = ({ req, onUpdate, onFulfil, isDark }) => {
//     const cardBg = isDark ? '#1a2132' : '#fff';
//     const border = isDark ? '#2d3748' : '#e5e7eb';
//     const text = isDark ? '#f3f4f6' : '#111827';
//     const muted = isDark ? '#9ca3af' : '#6b7280';
//     const status = normStatus(req.status);
//     const isRejected = status === 'REJECTED';
//     const warehouse = getWarehouseName(req);

//     return (
//         <div style={{ background: cardBg, border: `1px solid ${border}`, borderRadius: 10, padding: '16px 18px', marginBottom: 12, boxShadow: isDark ? '0 2px 8px rgba(0,0,0,0.3)' : '0 1px 3px rgba(0,0,0,0.05)', transition: 'box-shadow .2s' }}
//             onMouseEnter={e => e.currentTarget.style.boxShadow = isDark ? '0 4px 18px rgba(0,0,0,0.45)' : '0 4px 14px rgba(0,0,0,0.09)'}
//             onMouseLeave={e => e.currentTarget.style.boxShadow = isDark ? '0 2px 8px rgba(0,0,0,0.3)' : '0 1px 3px rgba(0,0,0,0.05)'}
//         >
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 8 }}>
//                 <div>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
//                         <span style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 14, color: '#6366f1' }}>{req.indentNumber}</span>
//                         <StatusPill status={req.status} />
//                         <span style={{ fontSize: 11, color: muted, background: isDark ? '#252d3d' : '#f3f4f6', padding: '2px 8px', borderRadius: 6, fontWeight: 600 }}>FY {req.fin_year}</span>
//                     </div>
//                     <div style={{ fontSize: 12, color: muted, marginTop: 4 }}>
//                         Outlet: <span style={{ color: text, fontWeight: 500 }}>{req?.outlet?.name || '—'}{req?.outlet?.city ? `, ${req.outlet.city}` : ''}</span>
//                         {warehouse && <> &nbsp;•&nbsp; Warehouse: <span style={{ color: text, fontWeight: 500 }}>{warehouse}</span></>}
//                     </div>
//                 </div>

//                 <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
//                     <div style={{ textAlign: 'right', fontSize: 12, color: muted }}>
//                         Raised on: <span style={{ color: text }}>{fmt(req.createdAt)}</span>
//                     </div>

//                     {ADMIN_ACTIONABLE.has(status) && (
//                         <button onClick={() => onUpdate(req)} style={{
//                             background: isRejected ? '#d1fae5' : '#f5f3ff', border: `1px solid ${isRejected ? '#6ee7b7' : '#ddd6fe'}`,
//                             borderRadius: 7, padding: '6px 13px', fontSize: 12, fontWeight: 700, color: isRejected ? '#059669' : '#7c3aed',
//                             cursor: 'pointer', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 5, fontFamily: 'inherit',
//                         }}
//                             onMouseEnter={e => e.currentTarget.style.background = isRejected ? '#a7f3d0' : '#ede9fe'}
//                             onMouseLeave={e => e.currentTarget.style.background = isRejected ? '#d1fae5' : '#f5f3ff'}
//                         >
//                             {isRejected ? '↻ Accept Again' : '✎ Accept / Reject'}
//                         </button>
//                     )}

//                     {FULFILLMENT_TRANSITIONS[status] && (
//                         <button onClick={() => onFulfil(req)} style={{
//                             background: '#cffafe', border: '1px solid #67e8f9', borderRadius: 7, padding: '6px 13px', fontSize: 12, fontWeight: 700,
//                             color: '#0891b2', cursor: 'pointer', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 5, fontFamily: 'inherit',
//                         }}
//                             onMouseEnter={e => e.currentTarget.style.background = '#a5f3fc'}
//                             onMouseLeave={e => e.currentTarget.style.background = '#cffafe'}
//                         >
//                             🚚 Update Status
//                         </button>
//                     )}

//                     <DownloadDropdown isDark={isDark} onPDF={() => handleDownloadPDF(req)} onExcel={() => handleDownloadExcel(req)} />
//                 </div>
//             </div>

//             <ItemsRow items={req.items || []} status={req.status} />
//         </div>
//     );
// };

// /* ─── Pagination ─────────────────────────────────────────── */
// const Pagination = ({ currentPage, totalPages, onPageChange, isDark }) => {
//     const borderCol = isDark ? '#2d3748' : '#e5e7eb';
//     const textMain = isDark ? '#f3f4f6' : '#111827';
//     const textMuted = isDark ? '#9ca3af' : '#6b7280';

//     const pages = [];
//     if (totalPages <= 5) for (let i = 1; i <= totalPages; i++) pages.push(i);
//     else if (currentPage <= 3) pages.push(1, 2, 3, 4, '...', totalPages);
//     else if (currentPage >= totalPages - 2) pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
//     else pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);

//     const btn = { border: `1px solid ${borderCol}`, borderRadius: 7, padding: '6px 12px', fontSize: 13, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer', background: isDark ? '#1e293b' : '#fff', color: textMain };

//     return (
//         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginTop: 20, flexWrap: 'wrap' }}>
//             <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} style={{ ...btn, color: currentPage === 1 ? textMuted : textMain, opacity: currentPage === 1 ? 0.5 : 1 }}>← Previous</button>
//             {pages.map((p, i) => p === '...'
//                 ? <span key={`e-${i}`} style={{ color: textMuted, padding: '0 4px' }}>...</span>
//                 : <button key={p} onClick={() => onPageChange(p)} style={{ ...btn, minWidth: 36, background: currentPage === p ? '#6366f1' : btn.background, border: `1px solid ${currentPage === p ? '#6366f1' : borderCol}`, color: currentPage === p ? '#fff' : textMain, fontWeight: currentPage === p ? 700 : 600 }}>{p}</button>
//             )}
//             <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} style={{ ...btn, color: currentPage === totalPages ? textMuted : textMain, opacity: currentPage === totalPages ? 0.5 : 1 }}>Next →</button>
//         </div>
//     );
// };

// /* ═══════════════════════════════════════════════════════════
//    MAIN COMPONENT
//    ═══════════════════════════════════════════════════════════ */
// const StockFlow = () => {
//     const [skin, setSkin] = useState(localStorage.getItem('skin-mode') ? 'dark' : '');
//     const accessToken = localStorage.getItem('authToken');

//     const [stockRequests, setStockRequests] = useState([]);
//     const [selectedOutlet, setSelectedOutlet] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState('');
//     const [searchTerm, setSearchTerm] = useState('');
//     const [statusFilter, setStatusFilter] = useState('ALL');
//     const [updateTarget, setUpdateTarget] = useState(null);
//     const [fulfilTarget, setFulfilTarget] = useState(null);

//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalRecords, setTotalRecords] = useState(0);
//     const [statusCounts, setStatusCounts] = useState({});

//     const [dateFilterKey, setDateFilterKey] = useState('LAST_30_DAYS');
//     const initialRange = getDateRangeForOption('LAST_30_DAYS');
//     const [startDate, setStartDate] = useState(initialRange.start);
//     const [endDate, setEndDate] = useState(initialRange.end);

//     const searchDebounceRef = useRef(null);
//     useEffect(() => () => { if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current); }, []);

//     const isDark = skin === 'dark';
//     const pageBg = isDark ? '#111827' : '#f3f4f6';
//     const cardBg = isDark ? '#1a2132' : '#fff';
//     const textMain = isDark ? '#f3f4f6' : '#111827';
//     const textMuted = isDark ? '#9ca3af' : '#6b7280';
//     const borderCol = isDark ? '#2d3748' : '#e5e7eb';

//     // Current filter values; `o` overrides whichever filter just changed (avoids stale state)
//     const currentFilters = (o = {}) => ({ search: searchTerm, outlet: selectedOutlet, status: statusFilter, startDate, endDate, ...o });

//     const getStockRequests = async (page = 1, f = currentFilters()) => {
//         setLoading(true); setError('');
//         try {
//             const headers = { Authorization: `Bearer ${accessToken}` };
//             const params = new URLSearchParams({ page, limit: PAGE_SIZE });
//             const outletId = f.outlet?.value || f.outlet?._id;
//             if (outletId) params.append('outlet', outletId);
//             // READY → covers Ready + Partial Ready, DISPATCH → Dispatched + Partially Dispatched, RECEIVED → Received + Partial Received
//             if (f.status && f.status !== 'ALL') params.append('status', toFilterStatus(f.status));
//             if (f.startDate) params.append('startDate', formatPayloadDate(f.startDate));
//             if (f.endDate) params.append('endDate', formatPayloadDate(f.endDate));
//             if (f.search && f.search.trim()) params.append('search', f.search.trim());

//             const res = await axiosInstance.get(`${API.LIST}?${params.toString()}`, { headers });
//             const body = res?.data?.data;
//             const list = (Array.isArray(body) ? body : body?.data || []).slice()
//                 .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//             const pagination = body?.pagination || res?.data?.pagination || {};
//             let counts = body?.statusCounts || res?.data?.statusCounts;
//             if (!counts) { // fallback: count what we have
//                 counts = {};
//                 list.forEach(r => { const k = camel(normStatus(r.status)); counts[k] = (counts[k] || 0) + 1; });
//             }

//             setStockRequests(list);
//             setCurrentPage(pagination.currentPage || page);
//             setTotalPages(pagination.totalPages || 1);
//             setTotalRecords(pagination.totalRecords || list.length);
//             setStatusCounts(counts);
//         } catch (err) {
//             setStockRequests([]); setCurrentPage(1); setTotalPages(1); setTotalRecords(0);
//             setStatusCounts(err?.response?.data?.statusCounts || {});
//             setError(err?.response?.status === 404 ? '' : 'There are no stock requests at the moment.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => { getStockRequests(1); }, []); // eslint-disable-line react-hooks/exhaustive-deps

//     const handleOutletChange = (option) => {
//         setSelectedOutlet(option); setCurrentPage(1);
//         getStockRequests(1, currentFilters({ outlet: option }));
//     };

//     const handleStatusChange = (s) => {
//         setStatusFilter(s); setCurrentPage(1);
//         getStockRequests(1, currentFilters({ status: s }));
//     };

//     const handleSearchChange = (value) => {
//         setSearchTerm(value);
//         if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
//         searchDebounceRef.current = setTimeout(() => {
//             setCurrentPage(1);
//             getStockRequests(1, currentFilters({ search: value }));
//         }, 400);
//     };

//     const handlePresetSelect = (key) => {
//         setDateFilterKey(key);
//         if (key === 'CUSTOM') return;
//         const { start, end } = getDateRangeForOption(key);
//         setStartDate(start); setEndDate(end); setCurrentPage(1);
//         getStockRequests(1, currentFilters({ startDate: start, endDate: end }));
//     };

//     const handleCustomDateChange = (type, value) => {
//         const parsed = value ? new Date(value + 'T00:00:00') : null;
//         setDateFilterKey('CUSTOM'); setCurrentPage(1);
//         if (type === 'start') { setStartDate(parsed); getStockRequests(1, currentFilters({ startDate: parsed })); }
//         else { setEndDate(parsed); getStockRequests(1, currentFilters({ endDate: parsed })); }
//     };

//     const handlePageChange = (page) => {
//         if (page < 1 || page > totalPages) return;
//         setCurrentPage(page);
//         getStockRequests(page);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     const refresh = () => getStockRequests(currentPage);

//     // Counts: a grouped chip (Ready / Dispatched / Received) adds its full + partial counts
//     // const countOne = (key) => statusCounts[key] ?? statusCounts[camel(key)] ?? 0;
//     const countOne = (key) => {
//         const found = (COUNT_KEYS[key] || [camel(key)]).find((k) => statusCounts[k] !== undefined);
//         return found ? Number(statusCounts[found]) || 0 : 0;
//     };
//     const countFor = (key) =>
//         (CHIP_GROUPS[key] || [key]).reduce((sum, k) => sum + (Number(countOne(k)) || 0), 0);
//     const allCount = Object.values(statusCounts).reduce((s, n) => s + (Number(n) || 0), 0);

//     // Partial statuses have no chip of their own — they are included in Ready / Dispatched / Received
//     const chips = [
//         { key: 'ALL', label: 'All' },
//         ...Object.keys(STATUS_CONFIG)
//             .filter(k => !HIDDEN_CHIPS.has(k))
//             .map(k => ({ key: k, label: STATUS_CONFIG[k].label })),
//     ];

//     return (
//         <React.Fragment>
//             <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
//             <Header onSkin={setSkin} />

//             {updateTarget && (
//                 <AcceptRejectModal request={updateTarget} onHide={() => setUpdateTarget(null)} onUpdated={refresh} accessToken={accessToken} />
//             )}

//             {fulfilTarget && (
//                 <FulfillmentModal request={fulfilTarget} onHide={() => setFulfilTarget(null)} onUpdated={refresh} accessToken={accessToken} />
//             )}

//             <div className={`main main-app p-3 p-lg-3 ${isDark ? 'bg-dark text-light' : 'bg-light'}`}
//                 style={{ minHeight: '100vh', background: pageBg, fontFamily: "'Nunito', 'Segoe UI', sans-serif" }}>
//                 <Container fluid>

//                     {/* Page header */}
//                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 22, flexWrap: 'wrap', gap: 12 }}>
//                         <div>
//                             <h4 style={{ fontWeight: 800, fontSize: 21, margin: 0, color: textMain, letterSpacing: '-0.01em' }}>Stock Requests</h4>
//                             <p style={{ color: textMuted, margin: '3px 0 0', fontSize: 13 }}>Accept outlet requests, assign a warehouse and track dispatch and receipt</p>
//                         </div>
//                         <button onClick={refresh} disabled={loading} style={{ background: '#6366f1', color: '#fff', border: 'none', borderRadius: 9, padding: '9px 18px', fontWeight: 700, fontSize: 13, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, display: 'flex', alignItems: 'center', gap: 7, fontFamily: 'inherit' }}>
//                             {loading ? <><Spinner animation="border" size="sm" /> Refreshing…</> : <><span style={{ fontSize: 15 }}>↺</span> Refresh</>}
//                         </button>
//                     </div>

//                     {/* Filters */}
//                     <div style={{ background: cardBg, border: `1px solid ${borderCol}`, borderRadius: 10, padding: 16, marginBottom: 14 }}>
//                         <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1.3fr 1.5fr', gap: 12 }}>
//                             <Form.Group controlId="outletSelect" style={{ margin: 0 }}>
//                                 <OutletSelect value={selectedOutlet} onChange={handleOutletChange} required={false} />
//                             </Form.Group>

//                             <DateRangeDropdown
//                                 dateFilterKey={dateFilterKey} startDate={startDate} endDate={endDate}
//                                 onPresetSelect={handlePresetSelect} onCustomDateChange={handleCustomDateChange} isDark={isDark}
//                             />

//                             <div>
//                                 <Form.Label style={{ color: textMuted, marginBottom: 6, fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
//                                     <i className="bi bi-search me-2"></i>Search
//                                 </Form.Label>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: isDark ? '#252d3d' : '#f9fafb', border: `1px solid ${borderCol}`, borderRadius: 8, padding: '8px 12px' }}>
//                                     <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={textMuted} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                                         <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
//                                     </svg>
//                                     <input value={searchTerm} onChange={e => handleSearchChange(e.target.value)} placeholder="Search by indent no. or material…"
//                                         style={{ border: 'none', background: 'transparent', flex: 1, outline: 'none', color: textMain, fontSize: 13, fontFamily: 'inherit' }} />
//                                     {searchTerm && <button onClick={() => handleSearchChange('')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: textMuted, fontSize: 18, lineHeight: 1, padding: 0 }}>×</button>}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Status chips */}
//                     {!loading && (
//                         <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
//                             {chips.map(({ key, label }) => {
//                                 const cfg = STATUS_CONFIG[key] || {};
//                                 const active = statusFilter === key;
//                                 return (
//                                     <button key={key} onClick={() => handleStatusChange(key)} style={{
//                                         border: `1.5px solid ${active ? (cfg.border || '#a5b4fc') : borderCol}`,
//                                         background: active ? (cfg.bg || '#eef2ff') : cardBg,
//                                         color: active ? (cfg.color || '#6366f1') : textMuted,
//                                         borderRadius: 20, padding: '5px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', transition: 'all .15s', fontFamily: 'inherit',
//                                     }}>
//                                         {label} ({key === 'ALL' ? allCount : countFor(key)})
//                                     </button>
//                                 );
//                             })}
//                         </div>
//                     )}

//                     {error && <div style={{ background: '#e4e2fe', border: '1px solid #a5a6fc', borderRadius: 9, padding: '11px 15px', marginBottom: 14, color: '#262fdc', fontSize: 13 }}>{error}</div>}

//                     {/* Loading skeleton */}
//                     {loading && (
//                         <>
//                             <style>{`@keyframes shimmer{0%,100%{opacity:1}50%{opacity:.4}}`}</style>
//                             {[1, 2, 3].map(i => (
//                                 <div key={i} style={{ background: cardBg, border: `1px solid ${borderCol}`, borderRadius: 10, padding: '16px 18px', marginBottom: 12, animation: 'shimmer 1.5s ease-in-out infinite' }}>
//                                     <div style={{ height: 14, width: '32%', background: isDark ? '#2d3748' : '#e5e7eb', borderRadius: 5, marginBottom: 10 }} />
//                                     <div style={{ height: 11, width: '20%', background: isDark ? '#2d3748' : '#e5e7eb', borderRadius: 5 }} />
//                                 </div>
//                             ))}
//                         </>
//                     )}

//                     {/* Empty state */}
//                     {!loading && !error && stockRequests.length === 0 && (
//                         <div style={{ background: cardBg, border: `1px solid ${borderCol}`, borderRadius: 10, padding: '52px 20px', textAlign: 'center' }}>
//                             <div style={{ fontSize: 36, marginBottom: 10 }}>📦</div>
//                             <div style={{ fontWeight: 800, fontSize: 15, color: textMain, marginBottom: 5 }}>{searchTerm ? 'No records found' : 'No stock requests found'}</div>
//                             <div style={{ color: textMuted, fontSize: 13 }}>
//                                 {searchTerm ? `No results for "${searchTerm}". Try a different indent number or material name.`
//                                     : statusFilter !== 'ALL' ? 'Try adjusting your filters'
//                                         : selectedOutlet?.value ? 'This outlet has no stock requests for the selected date range'
//                                             : 'Stock requisitions will appear here once raised'}
//                             </div>
//                         </div>
//                     )}

//                     {!loading && stockRequests.map(req => (
//                         <RequestCard key={req._id} req={req} isDark={isDark} onUpdate={setUpdateTarget} onFulfil={setFulfilTarget} />
//                     ))}

//                     {!loading && stockRequests.length > 0 && totalPages > 1 && (
//                         <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} isDark={isDark} />
//                     )}

//                     {!loading && stockRequests.length > 0 && (
//                         <div style={{ textAlign: 'center', color: textMuted, fontSize: 12, marginTop: 16, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
//                             <span>Showing {(currentPage - 1) * PAGE_SIZE + 1} - {Math.min(currentPage * PAGE_SIZE, totalRecords)} of {totalRecords} request{totalRecords !== 1 ? 's' : ''}</span>
//                             <span style={{ color: borderCol }}>•</span>
//                             <span>Page {currentPage} of {totalPages}</span>
//                         </div>
//                     )}
//                 </Container>
//             </div>
//         </React.Fragment>
//     );
// };

// export default StockFlow;


// NEW DESIGN
import React, { useState, useEffect, useRef } from 'react';
import Header from '../../layouts/Header';
import { Container, Spinner, Form } from 'react-bootstrap';
import Select from 'react-select';
import axiosInstance from '../../api/axios';
import OutletSelect from '../../components/OutletSelect';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx-js-style';
import IntendImages from '../../assets/img/indentImg.png';

/* ═══════════════════════════════════════════════════════════
   CONFIG — everything backend-dependent lives here.
   If a field/status name differs in the real response, fix it here only.
   ═══════════════════════════════════════════════════════════ */
const API = {
    LIST: 'stock-indent',
    UPDATE_STATUS: 'stock-indent/update-status',
    STORAGE_LOCATIONS: 'storage-location',
    UPDATE_FULFILLMENT: 'stock-indent/update-fullfillment-status', // PUT ?_id=... body { status }
};
const PAGE_SIZE = 30;

// Item-level quantity accessors
const qtyRequested = (it) => Number(it?.requestedQuantity || 0);
// "qty taken by logistic user".
// The list API has no dispatched field: logistics' picked qty comes back in totalReceivedQuantity
// (receivedQuantity for the latest round) while the indent is still at Ready / Dispatched stage.
// So: explicit field first, then — only at those stages — fall back to totalReceivedQuantity.
const DISPATCH_STAGE = new Set(['READY', 'PARTIAL_READY', 'PARTIAL_DISPATCHED', 'DISPATCHED']);
const qtyDispatched = (it, status) => {
    const explicit = it?.dispatchedQuantity ?? it?.readyQuantity ?? it?.pickedQuantity;
    if (explicit !== null && explicit !== undefined && explicit !== '') return Number(explicit);
    if (DISPATCH_STAGE.has(normStatus(status))) return Number(it?.totalReceivedQuantity ?? it?.receivedQuantity ?? 0);
    return 0;
};
const qtyReceived = (it) => Number(it?.totalReceivedQuantity || 0);

// Column label for the logistics/dispatch quantity
const READY_STAGE = new Set(['READY', 'PARTIAL_READY']);
const dispatchLabel = (status) => (READY_STAGE.has(normStatus(status)) ? 'Ready to Pick' : 'Dispatched Qty');

// Status lifecycle (paper flow):
// Pending → Accepted/Rejected → Ready/Partial Ready → Dispatched/Partially Dispatched → Received/Partial Received → Closed
const STATUS_CONFIG = {
    PENDING: { label: 'Pending', color: '#d97706', bg: '#fef3c7', border: '#fcd34d' },
    ACCEPTED: { label: 'Accepted', color: '#059669', bg: '#d1fae5', border: '#6ee7b7' },
    REJECTED: { label: 'Rejected', color: '#dc2626', bg: '#fee2e2', border: '#fca5a5' },
    READY: { label: 'Ready', color: '#0891b2', bg: '#cffafe', border: '#67e8f9' },
    PARTIAL_READY: { label: 'Partial Ready', color: '#0d9488', bg: '#ccfbf1', border: '#5eead4' },
    PARTIAL_DISPATCHED: { label: 'Partially Dispatched', color: '#7c3aed', bg: '#ede9fe', border: '#c4b5fd' },
    DISPATCHED: { label: 'Dispatched', color: '#4f46e5', bg: '#e0e7ff', border: '#a5b4fc' },
    PARTIAL_RECEIVED: { label: 'Partial Received', color: '#ea580c', bg: '#ffedd5', border: '#fdba74' },
    RECEIVED: { label: 'Received', color: '#2563eb', bg: '#dbeafe', border: '#93c5fd' },
    CLOSED: { label: 'Closed', color: '#374151', bg: '#f3f4f6', border: '#9ca3af' },
};

// Tolerates "PARTIAL-READY", "Partially Dispatched", "READY-TO-PICK" etc. from the API
const STATUS_ALIASES = {
    PARTIAL_DISPATCH: 'PARTIAL_DISPATCHED',
    PARTIALLY_DISPATCH: 'PARTIAL_DISPATCHED',
    PARTIALLY_DISPATCHED: 'PARTIAL_DISPATCHED',
    DISPATCH: 'DISPATCHED',
    PARTIALLY_READY: 'PARTIAL_READY',
    PARTIALLY_RECEIVED: 'PARTIAL_RECEIVED',
    READY_TO_PICK: 'READY',
};
const normStatus = (s) => {
    const k = String(s || '').trim().toUpperCase().replace(/[\s-]+/g, '_');
    return STATUS_ALIASES[k] || k;
};

// Which quantity columns make sense at each stage
const SHOW_DISPATCHED = new Set(['READY', 'PARTIAL_READY', 'PARTIAL_DISPATCHED', 'DISPATCHED', 'PARTIAL_RECEIVED', 'RECEIVED', 'CLOSED']);
const SHOW_RECEIVED = new Set(['PARTIAL_RECEIVED', 'RECEIVED', 'CLOSED']);

// Admin can only act on these
const ADMIN_ACTIONABLE = new Set(['PENDING', 'REJECTED']);

// UI status key → value the API expects for update-fullfillment-status
const API_STATUS = {
    READY: 'READY',
    PARTIAL_READY: 'PARTIALLY-READY',
    DISPATCHED: 'DISPATCH',
    PARTIAL_DISPATCHED: 'PARTIALLY-DISPATCH',
    PARTIAL_RECEIVED: 'PARTIALLY-RECEIVED',
};
const toApiStatus = (k) => API_STATUS[k] || k;

// Filter chips: one chip covers both the full and the partial status
const CHIP_GROUPS = {
    READY: ['READY', 'PARTIAL_READY'],
    DISPATCHED: ['DISPATCHED', 'PARTIAL_DISPATCHED'],
    RECEIVED: ['RECEIVED', 'PARTIAL_RECEIVED'],
};
const HIDDEN_CHIPS = new Set(['PARTIAL_READY', 'PARTIAL_DISPATCHED', 'PARTIAL_RECEIVED']);

// Names the API uses in statusCounts, per UI status (they don't match the UI keys 1:1)
const COUNT_KEYS = {
    PENDING: ['pending'],
    ACCEPTED: ['accepted'],
    REJECTED: ['rejected'],
    READY: ['ready'],
    PARTIAL_READY: ['partiallyReady', 'partialReady'],
    DISPATCHED: ['dispatch', 'dispatched'],
    PARTIAL_DISPATCHED: ['partiallyDispatch', 'partiallyDispatched', 'partialDispatched'],
    RECEIVED: ['received'],
    PARTIAL_RECEIVED: ['partiallyReceived', 'partialReceived'],
    CLOSED: ['closed'],
};

// Value sent to the LIST api for the status filter (backend returns full + partial for each)
const FILTER_API_STATUS = {
    READY: 'READY',
    DISPATCHED: 'DISPATCH',
    RECEIVED: 'RECEIVED',
};
const toFilterStatus = (k) => FILTER_API_STATUS[k] || k;

// Fulfilment updates the admin can make: current status → statuses it can move to.
// (Ready / Partial Ready are set by logistics, so Accepted has no admin fulfilment action.)
const FULFILLMENT_TRANSITIONS = {
    // READY: ['PARTIAL_DISPATCHED', 'DISPATCHED'],
    READY: ['DISPATCHED'],  // only fully dispatch
    // PARTIAL_READY: ['PARTIAL_DISPATCHED', 'DISPATCHED'],
    PARTIAL_READY: ['PARTIAL_DISPATCHED'],   // only partially dispatch
    PARTIAL_DISPATCHED: ['DISPATCHED'],
};
const FULFILLMENT_HINTS = {
    PARTIAL_DISPATCHED: 'Only part of the quantity has been taken. It is deducted from the warehouse.',
    DISPATCHED: 'The full quantity has been taken. It is deducted from the warehouse.',
};

const camel = (k) => k.toLowerCase().replace(/_([a-z])/g, (_, c) => c.toUpperCase());

/* ─── formatters ─────────────────────────────────────────── */
const fmt = (iso) =>
    new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
const formatDate = (iso) =>
    new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

// "#rrggbb" → rgba(r,g,b,a) — used for dark-mode tints
const hexA = (hex, a) => {
    const h = String(hex || '#6366f1').replace('#', '');
    const n = parseInt(h.length === 3 ? h.split('').map(c => c + c).join('') : h, 16);
    return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};

const DATE_FILTER_OPTIONS = [
    { key: 'TODAY', label: 'Today' },
    { key: 'YESTERDAY', label: 'Yesterday' },
    { key: 'LAST_7_DAYS', label: 'Last 7 Days' },
    { key: 'LAST_30_DAYS', label: 'Last 30 Days' },
    { key: 'LAST_MONTH', label: 'Last Month' },
    { key: 'LAST_3_MONTHS', label: 'Last 3 Months' },
    { key: 'CUSTOM', label: 'Custom Range' },
];

// YYYY-MM-DD — used for both the API payload and <input type="date">
const formatPayloadDate = (date) => {
    if (!date) return '';
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

const getDateRangeForOption = (key) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const start = new Date(today);
    const end = new Date(today);
    switch (key) {
        case 'YESTERDAY': start.setDate(start.getDate() - 1); end.setDate(end.getDate() - 1); break;
        case 'LAST_7_DAYS': start.setDate(start.getDate() - 6); break;
        case 'LAST_30_DAYS': start.setDate(start.getDate() - 29); break;
        case 'LAST_MONTH': {
            const lastDayPrev = new Date(today.getFullYear(), today.getMonth(), 1);
            lastDayPrev.setDate(0);
            return { start: new Date(lastDayPrev.getFullYear(), lastDayPrev.getMonth(), 1), end: lastDayPrev };
        }
        case 'LAST_3_MONTHS': start.setMonth(start.getMonth() - 3); start.setDate(start.getDate() + 1); break;
        default: break;
    }
    return { start, end };
};

const apiErrorMessage = (error, fallback = 'Failed to update. Please try again.') => {
    const d = error?.response?.data;
    const s = error?.response?.status;
    let msg = '';
    if (s === 406) msg = d?.error?.message || d?.error;
    else if (s === 412) msg = d?.data?.message || d?.error;
    else msg = d?.message || d?.error?.message || d?.error;
    return (typeof msg === 'string' && msg) || fallback;
};

const getWarehouseName = (req) =>
    req?.storageLocation && typeof req.storageLocation === 'object' ? req.storageLocation.name : '';

/* ═══════════════════════════════════════════════════════════
   DOWNLOADS (single indent)
   ═══════════════════════════════════════════════════════════ */
const sortItems = (items) =>
    [...items].sort((a, b) => {
        const c = (a.rawMaterial?.mainCategoryName || '').localeCompare(b.rawMaterial?.mainCategoryName || '');
        return c !== 0 ? c : (a.rawMaterial?.subCategoryName || '').localeCompare(b.rawMaterial?.subCategoryName || '');
    });

const handleDownloadPDF = (request) => {
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const primary = [9, 165, 247];
    const status = normStatus(request.status || 'PENDING');
    const showDisp = SHOW_DISPATCHED.has(status);
    const showRec = SHOW_RECEIVED.has(status);

    doc.setFillColor(...primary);
    doc.rect(0, 0, pageWidth, 28, 'F');
    try { doc.addImage(IntendImages, 'PNG', 10, 4, 50, 20); } catch (e) { /* logo optional */ }
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold'); doc.setFontSize(15);
    doc.text('STOCK REQUEST', pageWidth - 14, 13, { align: 'right' });
    doc.setFontSize(8); doc.setFont('helvetica', 'normal');
    doc.text(`${request.indentNumber || ''}`, pageWidth - 14, 20, { align: 'right' });
    doc.setTextColor(40, 40, 40);

    const y = 36;
    const pair = (label, value, lx, vx, yy) => {
        doc.setFont('helvetica', 'normal'); doc.text(label, lx, yy);
        doc.setFont('helvetica', 'bold'); doc.text(String(value), vx, yy);
    };
    doc.setFontSize(8.5);
    pair('Indent :', request.indentNumber || '-', 14, 38, y);
    pair('Status :', STATUS_CONFIG[status]?.label || status, 14, 38, y + 6);
    pair('Date :', formatDate(request.createdAt), 14, 38, y + 12);
    pair('Fin. Year :', request.fin_year || '-', 14, 38, y + 18);
    pair('Outlet :', request?.outlet?.name || '-', 110, 128, y);
    pair('City :', request?.outlet?.city || '-', 110, 128, y + 6);
    pair('Warehouse :', getWarehouseName(request) || '-', 110, 128, y + 12);

    const dividerY = y + 26;
    doc.setDrawColor(200, 200, 200);
    doc.line(14, dividerY, pageWidth - 14, dividerY);

    const items = sortItems(request.items || []);
    const head = [['Sr No', 'Material', 'Main Cat', 'Sub Cat', 'Unit', 'Req Qty']];
    // if (showDisp) head[0].push('Disp Qty');
    if (showDisp) head[0].push(dispatchLabel(status));
    if (showRec) head[0].push('Rec Qty', 'Balance');

    let tReq = 0, tDisp = 0, tRec = 0;
    const body = items.map((it, i) => {
        const rm = it.rawMaterial || {};
        const r = qtyRequested(it), d = qtyDispatched(it, status), c = qtyReceived(it);
        tReq += r; tDisp += d; tRec += c;
        const row = [i + 1, rm.name || '-', rm.mainCategoryName || '-', rm.subCategoryName || '-', rm.unit || '-', r.toFixed(2)];
        if (showDisp) row.push(d.toFixed(2));
        if (showRec) row.push(c.toFixed(2), (r - c).toFixed(2));
        return row;
    });

    const columnStyles = { 0: { halign: 'center', cellWidth: 10 }, 1: { halign: 'left' } };
    for (let i = 2; i < head[0].length; i++) columnStyles[i] = { halign: 'center' };

    autoTable(doc, {
        startY: dividerY + 6, head, body, theme: 'grid',
        headStyles: { fillColor: primary, textColor: 255, fontStyle: 'bold', halign: 'center', fontSize: 8 },
        styles: { fontSize: 8, cellPadding: 2.5, font: 'helvetica', valign: 'middle' },
        alternateRowStyles: { fillColor: [245, 250, 255] },
        columnStyles,
    });

    const finalY = doc.lastAutoTable.finalY + 8;
    doc.setFontSize(8.5); doc.setFont('helvetica', 'bold');
    let totals = `Total Items: ${items.length}   |   Requested: ${tReq.toFixed(2)}`;
    // if (showDisp) totals += `   |   Dispatched: ${tDisp.toFixed(2)}`;
    if (showDisp) totals += `   |   ${dispatchLabel(status).replace(' Qty', '')}: ${tDisp.toFixed(2)}`;
    if (showRec) totals += `   |   Received: ${tRec.toFixed(2)}   |   Balance: ${(tReq - tRec).toFixed(2)}`;
    doc.text(totals, pageWidth - 14, finalY, { align: 'right' });

    doc.setFont('helvetica', 'normal');
    doc.text('Authorized Signature', pageWidth - 60, finalY + 18);
    doc.line(pageWidth - 60, finalY + 20, pageWidth - 14, finalY + 20);
    doc.setFontSize(7); doc.setTextColor(100, 100, 100);
    doc.text(`Generated on ${new Date().toLocaleString('en-IN')}`, 14, doc.internal.pageSize.getHeight() - 10);
    doc.save(`Stock-Request-${request.indentNumber || 'Details'}.pdf`);
};

const XL = { PRIMARY: '09A5F7', WHITE: 'FFFFFF', DARK: '1F2937', MUTED: '6B7280', ALT: 'F0F7FF', TOTAL: 'EEF2FF', INDIGO: '4F46E5', GREEN: '059669', RED: 'DC2626' };
const xlBorder = (color = 'D1D5DB') => {
    const e = { style: 'thin', color: { rgb: color } };
    return { top: e, bottom: e, left: e, right: e };
};
const xlCell = (v, o = {}) => ({
    v, t: typeof v === 'number' ? 'n' : 's',
    ...(typeof v === 'number' ? { z: '#,##0.00' } : {}),
    s: {
        font: { name: 'Arial', sz: o.sz || 10, bold: !!o.bold, color: { rgb: o.color || XL.DARK } },
        ...(o.bg ? { fill: { fgColor: { rgb: o.bg } } } : {}),
        alignment: { horizontal: o.align || 'left', vertical: 'center', wrapText: true },
        ...(o.noBorder ? {} : { border: xlBorder(o.borderColor) }),
    },
});

const handleDownloadExcel = (request) => {
    const status = normStatus(request.status || 'PENDING');
    const showDisp = SHOW_DISPATCHED.has(status);
    const showRec = SHOW_RECEIVED.has(status);
    const headers = ['Sr No', 'Material', 'Main Category', 'Sub Category', 'HSN', 'Unit', 'Req Qty'];
    // if (showDisp) headers.push('Disp Qty');
    if (showDisp) headers.push(dispatchLabel(status));
    if (showRec) headers.push('Rec Qty', 'Balance');
    const last = headers.length - 1;
    const ws = { '!merges': [] };
    const put = (r, c, cell) => { ws[XLSX.utils.encode_cell({ r, c })] = cell; };
    const merge = (r, c1, c2) => ws['!merges'].push({ s: { r, c: c1 }, e: { r, c: c2 } });
    const banner = (r, text, o) => {
        for (let c = 0; c <= last; c++) put(r, c, xlCell(c === 0 ? text : '', { ...o, bg: XL.PRIMARY, color: XL.WHITE, align: 'center', noBorder: true }));
        merge(r, 0, last);
    };

    banner(0, 'STOCK REQUEST', { sz: 16, bold: true });
    banner(1, request.indentNumber || '', { sz: 9 });

    const left = [['Indent Number', request.indentNumber || '-'], ['Status', STATUS_CONFIG[status]?.label || status], ['Date', formatDate(request.createdAt)], ['Financial Year', request.fin_year || '-']];
    const right = [['Outlet', request?.outlet?.name || '-'], ['City', request?.outlet?.city || '-'], ['Warehouse', getWarehouseName(request) || '-'], ['', '']];
    left.forEach(([l, v], i) => {
        const r = 3 + i;
        put(r, 0, xlCell(l, { bold: true, color: XL.MUTED, bg: 'F9FAFB', sz: 9 }));
        for (let c = 1; c <= 3; c++) put(r, c, xlCell(c === 1 ? v : '', { bold: true, bg: 'F9FAFB', sz: 9 }));
        merge(r, 1, 3);
        put(r, 4, xlCell(right[i][0], { bold: true, color: XL.MUTED, bg: 'F9FAFB', sz: 9 }));
        for (let c = 5; c <= last; c++) put(r, c, xlCell(c === 5 ? right[i][1] : '', { bold: true, bg: 'F9FAFB', sz: 9 }));
        merge(r, 5, last);
    });

    headers.forEach((h, c) => put(8, c, xlCell(h, { bold: true, color: XL.WHITE, bg: XL.PRIMARY, align: 'center', borderColor: XL.PRIMARY })));

    let tReq = 0, tDisp = 0, tRec = 0;
    sortItems(request.items || []).forEach((it, idx) => {
        const rm = it.rawMaterial || {};
        const r = qtyRequested(it), d = qtyDispatched(it, status), c = qtyReceived(it);
        tReq += r; tDisp += d; tRec += c;
        const row = 9 + idx;
        const o = { bg: idx % 2 ? XL.ALT : XL.WHITE };
        const cells = [
            xlCell(idx + 1, { ...o, align: 'center' }), xlCell(rm.name || '-', o),
            xlCell(rm.mainCategoryName || '-', { ...o, align: 'center' }), xlCell(rm.subCategoryName || '-', { ...o, align: 'center' }),
            xlCell(rm.hsn || '-', { ...o, align: 'center' }), xlCell(rm.unit || '-', { ...o, align: 'center' }),
            xlCell(r, { ...o, align: 'center', bold: true, color: XL.INDIGO }),
        ];
        if (showDisp) cells.push(xlCell(d, { ...o, align: 'center', bold: true, color: '7C3AED' }));
        if (showRec) cells.push(xlCell(c, { ...o, align: 'center', bold: true, color: XL.GREEN }), xlCell(r - c, { ...o, align: 'center', bold: true, color: r - c > 0 ? XL.RED : XL.GREEN }));
        cells.forEach((cell, ci) => put(row, ci, cell));
    });

    const tr = 9 + (request.items || []).length;
    const tot = (v, a = 'center', color = XL.INDIGO) => xlCell(v, { bold: true, sz: 11, bg: XL.TOTAL, align: a, color, borderColor: 'C4B5FD' });
    const totals = [tot(''), tot(''), tot(''), tot(''), tot(''), tot('TOTAL', 'right', XL.DARK), tot(tReq)];
    if (showDisp) totals.push(tot(tDisp, 'center', '7C3AED'));
    if (showRec) totals.push(tot(tRec, 'center', XL.GREEN), tot(tReq - tRec, 'center', XL.RED));
    totals.forEach((cell, c) => put(tr, c, cell));

    put(tr + 2, 0, xlCell(`Generated on ${new Date().toLocaleString('en-IN')}`, { sz: 8, color: XL.MUTED, noBorder: true }));
    merge(tr + 2, 0, last);

    ws['!cols'] = [{ wch: 7 }, { wch: 30 }, { wch: 18 }, { wch: 18 }, { wch: 12 }, { wch: 10 }, ...Array(headers.length - 6).fill({ wch: 13 })];
    ws['!rows'] = [{ hpt: 30 }, { hpt: 18 }, { hpt: 6 }, { hpt: 18 }, { hpt: 18 }, { hpt: 18 }, { hpt: 18 }, { hpt: 6 }, { hpt: 22 }];
    ws['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: tr + 2, c: last } });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Stock Request');
    XLSX.writeFile(wb, `Stock-Request-${request.indentNumber || 'Details'}.xlsx`);
};

/* ═══════════════════════════════════════════════════════════
   SMALL UI PIECES
   ═══════════════════════════════════════════════════════════ */
const useClickOutside = (ref, onOutside) => {
    useEffect(() => {
        const h = (e) => { if (ref.current && !ref.current.contains(e.target)) onOutside(); };
        document.addEventListener('mousedown', h);
        return () => document.removeEventListener('mousedown', h);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

const DownloadDropdown = ({ onPDF, onExcel, label = '⬇ Download', isDark }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useClickOutside(ref, () => setOpen(false));

    const itemStyle = (last) => ({
        display: 'flex', alignItems: 'center', gap: 8, width: '100%', background: 'none', border: 'none',
        padding: '9px 14px', fontSize: 13, fontWeight: 600, color: isDark ? '#f3f4f6' : '#374151',
        cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
        borderBottom: last ? 'none' : `1px solid ${isDark ? '#2d3748' : '#f3f4f6'}`,
    });

    return (
        <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
            <button onClick={() => setOpen(o => !o)} style={{
                background: isDark ? 'rgba(251,191,36,0.12)' : 'linear-gradient(135deg,#fffbeb,#fef3c7)', border: `1px solid ${isDark ? 'rgba(251,191,36,0.4)' : '#fcd34d'}`,
                borderRadius: 8, padding: '7px 13px', fontSize: 12, fontWeight: 700, color: '#d97706', cursor: 'pointer', whiteSpace: 'nowrap',
                display: 'flex', alignItems: 'center', gap: 6, fontFamily: 'inherit', transition: 'transform .15s, box-shadow .15s',
            }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 4px 10px rgba(217,119,6,0.18)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
            >
                {label}
                <span style={{ fontSize: 9, display: 'inline-block', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}>▼</span>
            </button>
            {open && (
                <div style={{
                    position: 'absolute', right: 0, top: 'calc(100% + 4px)', background: isDark ? '#1e293b' : '#fff',
                    border: `1px solid ${isDark ? '#2d3748' : '#e5e7eb'}`, borderRadius: 10,
                    boxShadow: '0 10px 28px rgba(0,0,0,0.14)', minWidth: 160, zIndex: 200, overflow: 'hidden',
                }}>
                    <button onClick={() => { onPDF(); setOpen(false); }} style={itemStyle(false)}><span>📄</span> Download PDF</button>
                    <button onClick={() => { onExcel(); setOpen(false); }} style={itemStyle(true)}><span>📊</span> Download Excel</button>
                </div>
            )}
        </div>
    );
};

const DateRangeDropdown = ({ dateFilterKey, startDate, endDate, onPresetSelect, onCustomDateChange, isDark }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useClickOutside(ref, () => setOpen(false));

    const borderCol = isDark ? '#2d3748' : '#e5e7eb';
    const textMain = isDark ? '#f3f4f6' : '#111827';
    const textMuted = isDark ? '#9ca3af' : '#6b7280';
    const selectedLabel = DATE_FILTER_OPTIONS.find(o => o.key === dateFilterKey)?.label || 'Select Range';
    const dateInput = { flex: 1, background: isDark ? '#252d3d' : '#fff', border: `1px solid ${borderCol}`, borderRadius: 6, padding: '6px 8px', fontSize: 12, color: textMain, fontFamily: 'inherit', outline: 'none' };

    return (
        <div ref={ref} style={{ position: 'relative' }}>
            <Form.Label style={{ color: textMuted, marginBottom: 6, fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                <i className="bi bi-calendar-range me-2"></i>Date Range
            </Form.Label>
            <button type="button" onClick={() => setOpen(o => !o)} style={{
                width: '100%', textAlign: 'left', background: isDark ? '#252d3d' : '#f9fafb', border: `1px solid ${borderCol}`,
                borderRadius: 8, padding: '8px 12px', fontSize: 13, color: textMain, fontFamily: 'inherit', cursor: 'pointer',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            }}>
                <span>
                    {selectedLabel}
                    {dateFilterKey === 'CUSTOM' && startDate && endDate && (
                        <span style={{ color: textMuted, marginLeft: 6, fontSize: 11 }}>({formatPayloadDate(startDate)} – {formatPayloadDate(endDate)})</span>
                    )}
                </span>
                <span style={{ fontSize: 9, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}>▼</span>
            </button>

            {open && (
                <div style={{
                    position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, minWidth: 260,
                    background: isDark ? '#1e293b' : '#fff', border: `1px solid ${borderCol}`, borderRadius: 8,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 300, overflow: 'hidden',
                }}>
                    {DATE_FILTER_OPTIONS.filter(o => o.key !== 'CUSTOM').map(opt => (
                        <button type="button" key={opt.key} onClick={() => { onPresetSelect(opt.key); setOpen(false); }} style={{
                            display: 'block', width: '100%', textAlign: 'left', border: 'none', padding: '9px 14px', fontSize: 13, fontWeight: 600,
                            background: dateFilterKey === opt.key ? (isDark ? '#252d3d' : '#eef2ff') : 'transparent',
                            color: dateFilterKey === opt.key ? '#6366f1' : textMain, cursor: 'pointer', fontFamily: 'inherit',
                            borderBottom: `1px solid ${isDark ? '#2d3748' : '#f3f4f6'}`,
                        }}>{opt.label}</button>
                    ))}
                    <div style={{ padding: '10px 14px', background: isDark ? '#1a2132' : '#fafafa' }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: textMuted, marginBottom: 8 }}>Custom Range</div>
                        <div style={{ display: 'flex', gap: 8 }}>
                            <input type="date" value={formatPayloadDate(startDate)} max={formatPayloadDate(endDate) || formatPayloadDate(new Date())}
                                onChange={(e) => onCustomDateChange('start', e.target.value)} style={dateInput} />
                            <input type="date" value={formatPayloadDate(endDate)} min={formatPayloadDate(startDate)} max={formatPayloadDate(new Date())}
                                onChange={(e) => onCustomDateChange('end', e.target.value)} style={dateInput} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const StatusPill = ({ status, isDark }) => {
    const key = normStatus(status);
    const cfg = STATUS_CONFIG[key] || { label: status, color: '#6b7280', bg: '#f3f4f6', border: '#d1d5db' };
    return (
        <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '3px 11px', borderRadius: 20, fontSize: 11, fontWeight: 800, letterSpacing: '0.04em',
            textTransform: 'uppercase', color: cfg.color, whiteSpace: 'nowrap',
            background: isDark ? hexA(cfg.color, 0.16) : cfg.bg, border: `1px solid ${isDark ? hexA(cfg.color, 0.45) : cfg.border}`,
        }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: cfg.color }} />
            {cfg.label}
        </span>
    );
};

/* ─── Items toggle button (lives in the summary strip) ─────── */
const ItemsToggle = ({ count, open, onToggle, isDark, accent }) => (
    <button onClick={onToggle} style={{
        background: isDark ? hexA(accent, 0.14) : hexA(accent, 0.08), border: `1px solid ${hexA(accent, isDark ? 0.4 : 0.25)}`,
        borderRadius: 8, padding: '5px 10px', cursor: 'pointer', display: 'inline-flex', flexShrink: 0,
        alignItems: 'center', gap: 7, color: accent, fontSize: 12, fontWeight: 700, fontFamily: 'inherit', whiteSpace: 'nowrap', transition: 'background .15s',
    }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 18, height: 18, padding: '0 5px', borderRadius: 5, background: accent, color: '#fff', fontSize: 10, fontWeight: 800 }}>{count}</span>
        {open ? 'Hide' : 'View'} Item{count !== 1 ? 's' : ''}
        <span style={{ fontSize: 9, display: 'inline-block', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}>▼</span>
    </button>
);

/* ─── Items table (shown below the strip when open) ────────── */
const ItemsTable = ({ items, status, isDark, accent }) => {
    const key = normStatus(status);
    const showDisp = SHOW_DISPATCHED.has(key);
    const showRec = SHOW_RECEIVED.has(key);
    const cols = `2.5fr 1fr 1fr 1fr 130px${showDisp ? ' 130px' : ''}${showRec ? ' 130px 130px' : ''}`;

    const border = isDark ? '#2d3748' : '#e5e7eb';
    const rowBorder = isDark ? '#273244' : '#f3f4f6';
    const text = isDark ? '#f3f4f6' : '#111827';
    const muted = isDark ? '#9ca3af' : '#6b7280';
    const tableBg = isDark ? '#141b2b' : '#fff';

    const qtyCell = (v, unit, color) => (
        <span style={{ textAlign: 'left', fontWeight: 700, color, fontSize: 14 }}>
            {v.toFixed(2)} <span style={{ fontSize: 12, fontWeight: 500 }}>{unit}</span>
        </span>
    );

    return (
        <div style={{ marginTop: 10, border: `1px solid ${border}`, borderRadius: 10, overflow: 'hidden', background: tableBg }}>
            <div style={{ display: 'grid', gridTemplateColumns: cols, background: isDark ? hexA(accent, 0.14) : hexA(accent, 0.07), padding: '8px 14px', borderBottom: `1px solid ${border}`, fontSize: 11, fontWeight: 800, color: muted, letterSpacing: '0.05em', textTransform: 'uppercase' }}>
                <span>Material</span><span>Category</span><span>HSN</span><span>Unit</span>
                <span>Requested Qty</span>
                {showDisp && <span>{dispatchLabel(key)}</span>}
                {showRec && <span>Received Qty</span>}
                {showRec && <span>Balance Qty</span>}
            </div>
            {items.map((item, idx) => {
                const rm = item.rawMaterial || {};
                const r = qtyRequested(item), d = qtyDispatched(item, key), c = qtyReceived(item);
                return (
                    <div key={item._id || idx} style={{
                        display: 'grid', gridTemplateColumns: cols, padding: '9px 14px', alignItems: 'center', fontSize: 13,
                        background: idx % 2 === 0 ? 'transparent' : (isDark ? 'rgba(255,255,255,0.02)' : '#fafbff'),
                        borderBottom: idx < items.length - 1 ? `1px solid ${rowBorder}` : 'none',
                    }}>
                        <div>
                            <div style={{ fontWeight: 600, color: text }}>{rm.name || '—'}</div>
                            {rm.description && <div style={{ color: muted, fontSize: 11, marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>{rm.description}</div>}
                        </div>
                        <span style={{ color: text, fontSize: 12 }}>
                            {rm.subCategoryName}
                            <div style={{ color: muted, fontSize: 12 }}>{rm.mainCategoryName || '—'}</div>
                        </span>
                        <span style={{ color: muted, fontFamily: 'monospace', fontSize: 12 }}>{rm.hsn || '—'}</span>
                        <span style={{ color: muted, fontSize: 12 }}>{rm.unit || '—'}</span>
                        {qtyCell(r, rm.unit, '#6366f1')}
                        {showDisp && qtyCell(d, rm.unit, '#7c3aed')}
                        {showRec && qtyCell(c, rm.unit, '#059669')}
                        {showRec && qtyCell(r - c, rm.unit, r - c > 0 ? '#dc2626' : '#059669')}
                    </div>
                );
            })}
        </div>
    );
};

/* ─── Modal shell (shared by Accept/Reject modal) ─────────── */
const ModalShell = ({ title, onHide, children, footer }) => (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1050, background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onHide}>
        <div style={{ background: '#fff', borderRadius: 14, width: '100%', maxWidth: 440, margin: '0 16px', boxShadow: '0 20px 60px rgba(0,0,0,0.18)' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #f3f4f6' }}>
                <span style={{ fontWeight: 800, fontSize: 16, color: '#111827' }}>{title}</span>
                <button onClick={onHide} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 22, color: '#9ca3af', lineHeight: 1, padding: 0 }}>×</button>
            </div>
            <div style={{ padding: 20 }}>{children}</div>
            <div style={{ padding: '12px 20px', borderTop: '1px solid #f3f4f6', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>{footer}</div>
        </div>
    </div>
);

/* ─── Accept / Reject modal ───────────────────────────────── */
// ACCEPTED → warehouse (storageLocation) mandatory. REJECTED → not sent.
// A REJECTED indent can only be accepted again.
const AcceptRejectModal = ({ request, onHide, onUpdated, accessToken }) => {
    const wasRejected = normStatus(request.status) === 'REJECTED';
    const [status, setStatus] = useState('ACCEPTED');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [locations, setLocations] = useState([]);
    const [loadingLocations, setLoadingLocations] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const defaultApplied = useRef(false);

    const options = wasRejected ? ['ACCEPTED'] : ['ACCEPTED', 'REJECTED'];
    const headers = { Authorization: `Bearer ${accessToken}` };

    useEffect(() => {
        (async () => {
            setLoadingLocations(true);
            try {
                const res = await axiosInstance.get(API.STORAGE_LOCATIONS, { headers });
                setLocations(res?.data?.data?.storageLocations || []);
            } catch (e) { /* select just shows no options */ }
            finally { setLoadingLocations(false); }
        })();
    }, [accessToken]); // eslint-disable-line react-hooks/exhaustive-deps

    const locationOptions = locations.map(l => ({ value: l._id, label: l.name, sublabel: l.city }));

    // Preselect the outlet's default warehouse (user can still change it)
    useEffect(() => {
        if (defaultApplied.current || !locationOptions.length) return;
        const id = request?.outlet?.storageLocation?._id || request?.outlet?.storageLocation;
        const match = id && locationOptions.find(o => String(o.value) === String(id));
        if (match) { setSelectedLocation(match); defaultApplied.current = true; }
    }, [locations, request]); // eslint-disable-line react-hooks/exhaustive-deps

    const selectStyles = {
        control: (b, s) => ({ ...b, background: '#fff', borderColor: s.isFocused ? '#6366f1' : '#e5e7eb', borderWidth: 1.5, borderRadius: 9, minHeight: 42, boxShadow: s.isFocused ? '0 0 0 3px rgba(99,102,241,0.15)' : 'none', '&:hover': { borderColor: '#6366f1' }, fontSize: 13, fontWeight: 600 }),
        menu: (b) => ({ ...b, borderRadius: 10, zIndex: 9999 }),
        menuPortal: (b) => ({ ...b, zIndex: 9999 }),
        option: (b, s) => ({ ...b, background: s.isSelected ? '#6366f1' : s.isFocused ? '#eef2ff' : 'transparent', color: s.isSelected ? '#fff' : '#111827', fontSize: 13, padding: '10px 14px', cursor: 'pointer' }),
        indicatorSeparator: () => ({ display: 'none' }),
    };

    const handleSave = async () => {
        if (status === 'ACCEPTED' && !selectedLocation) {
            setError('Please select a warehouse before accepting.');
            return;
        }
        setSaving(true); setError('');
        try {
            const payload = { _id: request._id, status };
            if (status === 'ACCEPTED') payload.storageLocation = selectedLocation.value;
            await axiosInstance.put(API.UPDATE_STATUS, payload, { headers });
            onUpdated();
            onHide();
        } catch (err) {
            setError(apiErrorMessage(err));
        } finally {
            setSaving(false);
        }
    };

    const blocked = saving || (status === 'ACCEPTED' && !selectedLocation);

    return (
        <ModalShell
            title={wasRejected ? 'Accept Stock Request' : 'Accept / Reject Stock Request'}
            onHide={onHide}
            footer={<>
                <button onClick={onHide} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 18px', fontSize: 13, fontWeight: 600, color: '#374151', cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
                <button onClick={handleSave} disabled={blocked} style={{ background: blocked ? '#a5b4fc' : '#6366f1', border: 'none', borderRadius: 8, padding: '8px 22px', fontSize: 13, fontWeight: 700, color: '#fff', cursor: blocked ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 7, fontFamily: 'inherit' }}>
                    {saving ? <><Spinner animation="border" size="sm" /> Saving…</> : 'Save Changes'}
                </button>
            </>}
        >
            <div style={{ marginBottom: 16, padding: '10px 14px', background: '#f9fafb', borderRadius: 8, border: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, marginBottom: 3, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Indent Number</div>
                    <div style={{ fontWeight: 700, color: '#6366f1', fontFamily: 'monospace', fontSize: 14 }}>{request.indentNumber}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Current Status</div>
                    <StatusPill status={request.status} />
                </div>
            </div>

            {wasRejected && (
                <div style={{ marginBottom: 14, padding: '10px 14px', borderRadius: 8, background: '#f9fafb', border: '1px solid #e5e7eb', color: '#6b7280', fontSize: 13 }}>
                    This request was rejected. You can accept it again.
                </div>
            )}

            <div style={{ marginBottom: 8, fontSize: 13, fontWeight: 700, color: '#374151' }}>
                Set Status {!wasRejected && <span style={{ fontWeight: 400, color: '#9ca3af', fontSize: 12 }}>(choose one)</span>}
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
                {options.map(key => {
                    const cfg = STATUS_CONFIG[key];
                    return (
                        <label key={key} style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '12px 14px', borderRadius: 10, cursor: 'pointer', border: `2px solid ${status === key ? cfg.border : '#e5e7eb'}`, background: status === key ? cfg.bg : '#fff', transition: 'all .15s' }}>
                            <input type="radio" name="status" value={key} checked={status === key} onChange={() => { setStatus(key); setError(''); }} style={{ accentColor: cfg.color, width: 15, height: 15 }} />
                            <span style={{ fontWeight: 700, fontSize: 13, color: cfg.color }}>{cfg.label}</span>
                        </label>
                    );
                })}
            </div>

            {status === 'ACCEPTED' && (
                <div style={{ marginTop: 16 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: '#374151' }}>Warehouse</span>
                        <span style={{ fontSize: 10, color: '#ef4444', fontWeight: 700, background: '#fee2e2', padding: '2px 6px', borderRadius: 5 }}>REQUIRED</span>
                    </div>
                    <Select
                        options={locationOptions}
                        value={selectedLocation}
                        onChange={setSelectedLocation}
                        formatOptionLabel={({ label, sublabel }) => (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <span style={{ fontWeight: 700, fontSize: 13 }}>{label}</span>
                                {sublabel && <span style={{ fontSize: 11, color: '#6b7280' }}>📍 {sublabel}</span>}
                            </div>
                        )}
                        placeholder={loadingLocations ? 'Loading warehouses…' : 'Select warehouse…'}
                        isLoading={loadingLocations}
                        styles={selectStyles}
                        isClearable
                        noOptionsMessage={() => 'No warehouses found'}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                    />
                    <div style={{ marginTop: 8, fontSize: 12, color: '#6b7280' }}>Logistics will see this indent under the selected warehouse.</div>
                </div>
            )}

            {error && <div style={{ marginTop: 12, padding: '10px 14px', background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 8, color: '#dc2626', fontSize: 13 }}>{error}</div>}
        </ModalShell>
    );
};

/* ─── Fulfilment status modal (Ready / Partially Ready / Partially Dispatched) ─── */
const FulfillmentModal = ({ request, onHide, onUpdated, accessToken }) => {
    const options = FULFILLMENT_TRANSITIONS[normStatus(request.status)] || [];
    const [status, setStatus] = useState(options[0]);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const handleSave = async () => {
        setSaving(true); setError('');
        try {
            await axiosInstance.put(
                API.UPDATE_FULFILLMENT,
                { status: toApiStatus(status) },
                { params: { _id: request._id }, headers: { Authorization: `Bearer ${accessToken}` } }
            );
            onUpdated();
            onHide();
        } catch (err) {
            setError(apiErrorMessage(err));
        } finally {
            setSaving(false);
        }
    };

    return (
        <ModalShell
            title="Update Indent Status"
            onHide={onHide}
            footer={<>
                <button onClick={onHide} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 18px', fontSize: 13, fontWeight: 600, color: '#374151', cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
                <button onClick={handleSave} disabled={saving || !status} style={{ background: saving ? '#a5b4fc' : '#6366f1', border: 'none', borderRadius: 8, padding: '8px 22px', fontSize: 13, fontWeight: 700, color: '#fff', cursor: saving ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', gap: 7, fontFamily: 'inherit' }}>
                    {saving ? <><Spinner animation="border" size="sm" /> Saving…</> : 'Update Status'}
                </button>
            </>}
        >
            <div style={{ marginBottom: 16, padding: '10px 14px', background: '#f9fafb', borderRadius: 8, border: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, marginBottom: 3, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Indent Number</div>
                    <div style={{ fontWeight: 700, color: '#6366f1', fontFamily: 'monospace', fontSize: 14 }}>{request.indentNumber}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Current Status</div>
                    <StatusPill status={request.status} />
                </div>
            </div>

            <div style={{ marginBottom: 8, fontSize: 13, fontWeight: 700, color: '#374151' }}>
                Move to <span style={{ fontWeight: 400, color: '#9ca3af', fontSize: 12 }}>(choose one)</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {options.map(key => {
                    const cfg = STATUS_CONFIG[key];
                    const active = status === key;
                    return (
                        <label key={key} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '11px 14px', borderRadius: 10, cursor: 'pointer', border: `2px solid ${active ? cfg.border : '#e5e7eb'}`, background: active ? cfg.bg : '#fff', transition: 'all .15s' }}>
                            <input type="radio" name="fulfilment" value={key} checked={active} onChange={() => { setStatus(key); setError(''); }} style={{ accentColor: cfg.color, width: 15, height: 15, marginTop: 2 }} />
                            <span>
                                <span style={{ display: 'block', fontWeight: 700, fontSize: 13, color: cfg.color }}>{cfg.label}</span>
                                <span style={{ display: 'block', fontSize: 12, color: '#6b7280', marginTop: 2 }}>{FULFILLMENT_HINTS[key]}</span>
                            </span>
                        </label>
                    );
                })}
            </div>

            {error && <div style={{ marginTop: 12, padding: '10px 14px', background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 8, color: '#dc2626', fontSize: 13 }}>{error}</div>}
        </ModalShell>
    );
};

/* ─── Meta chip (outlet / warehouse / date / FY) ──────────── */
const MetaChip = ({ icon, label, value, isDark }) => (
    <span style={{
        display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 10px', borderRadius: 8, fontSize: 12,
        background: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.75)',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : 'rgba(17,24,39,0.07)'}`,
        color: isDark ? '#9ca3af' : '#6b7280', maxWidth: '100%',
    }}>
        <span style={{ fontSize: 13 }}>{icon}</span>
        {label && <span>{label}</span>}
        <span style={{ color: isDark ? '#f3f4f6' : '#111827', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{value}</span>
    </span>
);

/* ─── Request Card ───────────────────────────────────────── */
const RequestCard = ({ req, onUpdate, onFulfil, isDark }) => {
    const [open, setOpen] = useState(false);
    const status = normStatus(req.status);
    const cfg = STATUS_CONFIG[status] || { label: req.status, color: '#6366f1', bg: '#eef2ff', border: '#c7d2fe' };
    const accent = cfg.color;
    const isRejected = status === 'REJECTED';
    const warehouse = getWarehouseName(req);
    const items = req.items || [];

    const text = isDark ? '#f3f4f6' : '#111827';
    const muted = isDark ? '#9ca3af' : '#6b7280';

    // Light, status-tinted gradient — fades to the card surface so content stays readable
    const restShadow = isDark ? '0 2px 8px rgba(0,0,0,0.3)' : `0 1px 3px rgba(17,24,39,0.05), 0 4px 14px ${hexA(accent, 0.07)}`;
    const hoverShadow = isDark ? `0 8px 22px rgba(0,0,0,0.5)` : `0 10px 26px ${hexA(accent, 0.18)}`;
    const cardBg = isDark
        ? `linear-gradient(135deg, ${hexA(accent, 0.16)} 0%, #1a2132 55%, #1a2132 100%)`
        : `linear-gradient(135deg, ${hexA(accent, 0.12)} 0%, ${hexA(accent, 0.04)} 38%, #ffffff 75%)`;

    // Progress across items: received (late stages) or dispatched/ready (mid stages)
    const showDisp = SHOW_DISPATCHED.has(status);
    const showRec = SHOW_RECEIVED.has(status);
    const tReq = items.reduce((s, it) => s + qtyRequested(it), 0);
    const tDisp = items.reduce((s, it) => s + qtyDispatched(it, status), 0);
    const tRec = items.reduce((s, it) => s + qtyReceived(it), 0);
    const progressVal = showRec ? tRec : tDisp;
    const pct = tReq > 0 ? Math.max(0, Math.min(100, Math.round((progressVal / tReq) * 100))) : 0;
    const progressLabel = showRec ? 'Received' : dispatchLabel(status).replace(' Qty', '');

    const btn = (bg, border, color, hoverBg) => ({
        base: { background: bg, border: `1px solid ${border}`, borderRadius: 8, padding: '7px 14px', fontSize: 12, fontWeight: 700, color, cursor: 'pointer', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: 6, fontFamily: 'inherit', transition: 'transform .15s, box-shadow .15s, background .15s' },
        hoverBg,
    });
    const actionBtn = (b, onClick, label) => (
        <button onClick={onClick} style={b.base}
            onMouseEnter={e => { e.currentTarget.style.background = b.hoverBg; e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = `0 4px 10px ${hexA(accent, 0.2)}`; }}
            onMouseLeave={e => { e.currentTarget.style.background = b.base.background; e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
        >{label}</button>
    );

    const acceptBtn = isRejected
        ? btn('linear-gradient(135deg,#ecfdf5,#d1fae5)', '#6ee7b7', '#059669', '#a7f3d0')
        : btn('linear-gradient(135deg,#faf5ff,#ede9fe)', '#ddd6fe', '#7c3aed', '#ddd6fe');
    const fulfilBtn = btn('linear-gradient(135deg,#ecfeff,#cffafe)', '#67e8f9', '#0891b2', '#a5f3fc');

    return (
        <div style={{
            position: 'relative', overflow: 'hidden', background: cardBg,
            border: `1px solid ${isDark ? hexA(accent, 0.3) : hexA(accent, 0.22)}`, borderLeft: `4px solid ${accent}`,
            borderRadius: 12, padding: '14px 18px 14px 20px', marginBottom: 14, boxShadow: restShadow,
            transition: 'box-shadow .2s, transform .2s',
        }}
            onMouseEnter={e => { e.currentTarget.style.boxShadow = hoverShadow; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow = restShadow; e.currentTarget.style.transform = 'none'; }}
        >
            {/* Header: identity + actions */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
                <div style={{ minWidth: 0, flex: '1 1 320px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                        <span style={{ fontFamily: 'monospace', fontWeight: 800, fontSize: 15, color: isDark ? '#a5b4fc' : '#4f46e5' }}>{req.indentNumber}</span>
                        <StatusPill status={req.status} isDark={isDark} />
                    </div>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
                        <MetaChip isDark={isDark} icon="🏬" label="Outlet" value={`${req?.outlet?.name || '—'}${req?.outlet?.city ? `, ${req.outlet.city}` : ''}`} />
                        {warehouse && <MetaChip isDark={isDark} icon="🏭" label="Warehouse" value={warehouse} />}
                        <MetaChip isDark={isDark} icon="🗓" label="Raised" value={fmt(req.createdAt)} />
                        {req.fin_year && <MetaChip isDark={isDark} icon="📘" value={`FY ${req.fin_year}`} />}
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    {ADMIN_ACTIONABLE.has(status) && actionBtn(acceptBtn, () => onUpdate(req), isRejected ? '↻ Accept Again' : '✎ Accept / Reject')}
                    {FULFILLMENT_TRANSITIONS[status] && actionBtn(fulfilBtn, () => onFulfil(req), '🚚 Update Status')}
                    <DownloadDropdown isDark={isDark} onPDF={() => handleDownloadPDF(req)} onExcel={() => handleDownloadExcel(req)} />
                </div>
            </div>

            {/* Summary strip: items, requested qty, progress, View Items button */}
            <div style={{
                display: 'flex', alignItems: 'center', gap: 18, flexWrap: 'wrap', marginTop: 12, padding: '8px 14px', borderRadius: 10,
                background: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.7)',
                border: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(17,24,39,0.06)'}`,
            }}>
                <div>
                    <div style={{ fontSize: 10, fontWeight: 800, color: muted, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Items</div>
                    <div style={{ fontSize: 16, fontWeight: 800, color: text }}>{items.length}</div>
                </div>
                <div>
                    <div style={{ fontSize: 10, fontWeight: 800, color: muted, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Requested Qty</div>
                    <div style={{ fontSize: 16, fontWeight: 800, color: '#6366f1' }}>{tReq.toFixed(2)}</div>
                </div>
                {(showDisp || showRec) && (
                    <div style={{ flex: '1 1 220px', minWidth: 200 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, fontWeight: 700, color: muted, marginBottom: 5 }}>
                            <span>{progressLabel}: <span style={{ color: text }}>{progressVal.toFixed(2)}</span> / {tReq.toFixed(2)}</span>
                            <span style={{ color: accent }}>{pct}%</span>
                        </div>
                        <div style={{ height: 7, borderRadius: 99, background: isDark ? 'rgba(255,255,255,0.1)' : hexA(accent, 0.15), overflow: 'hidden' }}>
                            <div style={{ width: `${pct}%`, height: '100%', borderRadius: 99, background: `linear-gradient(90deg, ${hexA(accent, 0.65)}, ${accent})`, transition: 'width .4s ease' }} />
                        </div>
                    </div>
                )}

                {/* View Items button — right corner of the strip */}
                <div style={{ marginLeft: 'auto' }}>
                    <ItemsToggle count={items.length} open={open} onToggle={() => setOpen(o => !o)} isDark={isDark} accent={accent} />
                </div>
            </div>

            {open && <ItemsTable items={items} status={req.status} isDark={isDark} accent={accent} />}
        </div>
    );
};

/* ─── Pagination ─────────────────────────────────────────── */
const Pagination = ({ currentPage, totalPages, onPageChange, isDark }) => {
    const borderCol = isDark ? '#2d3748' : '#e5e7eb';
    const textMain = isDark ? '#f3f4f6' : '#111827';
    const textMuted = isDark ? '#9ca3af' : '#6b7280';

    const pages = [];
    if (totalPages <= 5) for (let i = 1; i <= totalPages; i++) pages.push(i);
    else if (currentPage <= 3) pages.push(1, 2, 3, 4, '...', totalPages);
    else if (currentPage >= totalPages - 2) pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    else pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);

    const btn = { border: `1px solid ${borderCol}`, borderRadius: 7, padding: '6px 12px', fontSize: 13, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer', background: isDark ? '#1e293b' : '#fff', color: textMain };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginTop: 20, flexWrap: 'wrap' }}>
            <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} style={{ ...btn, color: currentPage === 1 ? textMuted : textMain, opacity: currentPage === 1 ? 0.5 : 1 }}>← Previous</button>
            {pages.map((p, i) => p === '...'
                ? <span key={`e-${i}`} style={{ color: textMuted, padding: '0 4px' }}>...</span>
                : <button key={p} onClick={() => onPageChange(p)} style={{ ...btn, minWidth: 36, background: currentPage === p ? '#6366f1' : btn.background, border: `1px solid ${currentPage === p ? '#6366f1' : borderCol}`, color: currentPage === p ? '#fff' : textMain, fontWeight: currentPage === p ? 700 : 600 }}>{p}</button>
            )}
            <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} style={{ ...btn, color: currentPage === totalPages ? textMuted : textMain, opacity: currentPage === totalPages ? 0.5 : 1 }}>Next →</button>
        </div>
    );
};

/* ═══════════════════════════════════════════════════════════
   MAIN COMPONENT
   ═══════════════════════════════════════════════════════════ */
const StockFlow = () => {
    const [skin, setSkin] = useState(localStorage.getItem('skin-mode') ? 'dark' : '');
    const accessToken = localStorage.getItem('authToken');

    const [stockRequests, setStockRequests] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('ALL');
    const [updateTarget, setUpdateTarget] = useState(null);
    const [fulfilTarget, setFulfilTarget] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [statusCounts, setStatusCounts] = useState({});

    const [dateFilterKey, setDateFilterKey] = useState('LAST_30_DAYS');
    const initialRange = getDateRangeForOption('LAST_30_DAYS');
    const [startDate, setStartDate] = useState(initialRange.start);
    const [endDate, setEndDate] = useState(initialRange.end);

    const searchDebounceRef = useRef(null);
    useEffect(() => () => { if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current); }, []);

    const isDark = skin === 'dark';
    const pageBg = isDark ? '#111827' : '#f3f4f6';
    const cardBg = isDark ? '#1a2132' : '#fff';
    const textMain = isDark ? '#f3f4f6' : '#111827';
    const textMuted = isDark ? '#9ca3af' : '#6b7280';
    const borderCol = isDark ? '#2d3748' : '#e5e7eb';

    // Current filter values; `o` overrides whichever filter just changed (avoids stale state)
    const currentFilters = (o = {}) => ({ search: searchTerm, outlet: selectedOutlet, status: statusFilter, startDate, endDate, ...o });

    const getStockRequests = async (page = 1, f = currentFilters()) => {
        setLoading(true); setError('');
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const params = new URLSearchParams({ page, limit: PAGE_SIZE });
            const outletId = f.outlet?.value || f.outlet?._id;
            if (outletId) params.append('outlet', outletId);
            // READY → covers Ready + Partial Ready, DISPATCH → Dispatched + Partially Dispatched, RECEIVED → Received + Partial Received
            if (f.status && f.status !== 'ALL') params.append('status', toFilterStatus(f.status));
            if (f.startDate) params.append('startDate', formatPayloadDate(f.startDate));
            if (f.endDate) params.append('endDate', formatPayloadDate(f.endDate));
            if (f.search && f.search.trim()) params.append('search', f.search.trim());

            const res = await axiosInstance.get(`${API.LIST}?${params.toString()}`, { headers });
            const body = res?.data?.data;
            const list = (Array.isArray(body) ? body : body?.data || []).slice()
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            const pagination = body?.pagination || res?.data?.pagination || {};
            let counts = body?.statusCounts || res?.data?.statusCounts;
            if (!counts) { // fallback: count what we have
                counts = {};
                list.forEach(r => { const k = camel(normStatus(r.status)); counts[k] = (counts[k] || 0) + 1; });
            }

            setStockRequests(list);
            setCurrentPage(pagination.currentPage || page);
            setTotalPages(pagination.totalPages || 1);
            setTotalRecords(pagination.totalRecords || list.length);
            setStatusCounts(counts);
        } catch (err) {
            setStockRequests([]); setCurrentPage(1); setTotalPages(1); setTotalRecords(0);
            setStatusCounts(err?.response?.data?.statusCounts || {});
            setError(err?.response?.status === 404 ? '' : 'There are no stock requests at the moment.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { getStockRequests(1); }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleOutletChange = (option) => {
        setSelectedOutlet(option); setCurrentPage(1);
        getStockRequests(1, currentFilters({ outlet: option }));
    };

    const handleStatusChange = (s) => {
        setStatusFilter(s); setCurrentPage(1);
        getStockRequests(1, currentFilters({ status: s }));
    };

    const handleSearchChange = (value) => {
        setSearchTerm(value);
        if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
        searchDebounceRef.current = setTimeout(() => {
            setCurrentPage(1);
            getStockRequests(1, currentFilters({ search: value }));
        }, 400);
    };

    const handlePresetSelect = (key) => {
        setDateFilterKey(key);
        if (key === 'CUSTOM') return;
        const { start, end } = getDateRangeForOption(key);
        setStartDate(start); setEndDate(end); setCurrentPage(1);
        getStockRequests(1, currentFilters({ startDate: start, endDate: end }));
    };

    const handleCustomDateChange = (type, value) => {
        const parsed = value ? new Date(value + 'T00:00:00') : null;
        setDateFilterKey('CUSTOM'); setCurrentPage(1);
        if (type === 'start') { setStartDate(parsed); getStockRequests(1, currentFilters({ startDate: parsed })); }
        else { setEndDate(parsed); getStockRequests(1, currentFilters({ endDate: parsed })); }
    };

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
        getStockRequests(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const refresh = () => getStockRequests(currentPage);

    // Counts: a grouped chip (Ready / Dispatched / Received) adds its full + partial counts
    const countOne = (key) => {
        const found = (COUNT_KEYS[key] || [camel(key)]).find((k) => statusCounts[k] !== undefined);
        return found ? Number(statusCounts[found]) || 0 : 0;
    };
    const countFor = (key) =>
        (CHIP_GROUPS[key] || [key]).reduce((sum, k) => sum + (Number(countOne(k)) || 0), 0);
    const allCount = Object.values(statusCounts).reduce((s, n) => s + (Number(n) || 0), 0);

    // Partial statuses have no chip of their own — they are included in Ready / Dispatched / Received
    const chips = [
        { key: 'ALL', label: 'All' },
        ...Object.keys(STATUS_CONFIG)
            .filter(k => !HIDDEN_CHIPS.has(k))
            .map(k => ({ key: k, label: STATUS_CONFIG[k].label })),
    ];

    return (
        <React.Fragment>
            <link href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
            <Header onSkin={setSkin} />

            {updateTarget && (
                <AcceptRejectModal request={updateTarget} onHide={() => setUpdateTarget(null)} onUpdated={refresh} accessToken={accessToken} />
            )}

            {fulfilTarget && (
                <FulfillmentModal request={fulfilTarget} onHide={() => setFulfilTarget(null)} onUpdated={refresh} accessToken={accessToken} />
            )}

            <div className={`main main-app p-3 p-lg-3 ${isDark ? 'bg-dark text-light' : 'bg-light'}`}
                style={{ minHeight: '100vh', background: pageBg, fontFamily: "'Nunito', 'Segoe UI', sans-serif" }}>
                <Container fluid>

                    {/* Page header */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 22, flexWrap: 'wrap', gap: 12 }}>
                        <div>
                            <h4 style={{ fontWeight: 800, fontSize: 21, margin: 0, color: textMain, letterSpacing: '-0.01em' }}>Stock Requests</h4>
                            <p style={{ color: textMuted, margin: '3px 0 0', fontSize: 13 }}>Accept outlet requests, assign a warehouse and track dispatch and receipt</p>
                        </div>
                        <button onClick={refresh} disabled={loading} style={{ background: 'linear-gradient(135deg,#6366f1,#818cf8)', color: '#fff', border: 'none', borderRadius: 9, padding: '9px 18px', fontWeight: 700, fontSize: 13, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, display: 'flex', alignItems: 'center', gap: 7, fontFamily: 'inherit', boxShadow: '0 4px 12px rgba(99,102,241,0.3)' }}>
                            {loading ? <><Spinner animation="border" size="sm" /> Refreshing…</> : <><span style={{ fontSize: 15 }}>↺</span> Refresh</>}
                        </button>
                    </div>

                    {/* Filters */}
                    <div style={{ background: cardBg, border: `1px solid ${borderCol}`, borderRadius: 12, padding: 16, marginBottom: 14 }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1.3fr 1.5fr', gap: 12 }}>
                            <Form.Group controlId="outletSelect" style={{ margin: 0 }}>
                                <OutletSelect value={selectedOutlet} onChange={handleOutletChange} required={false} />
                            </Form.Group>

                            <DateRangeDropdown
                                dateFilterKey={dateFilterKey} startDate={startDate} endDate={endDate}
                                onPresetSelect={handlePresetSelect} onCustomDateChange={handleCustomDateChange} isDark={isDark}
                            />

                            <div>
                                <Form.Label style={{ color: textMuted, marginBottom: 6, fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                    <i className="bi bi-search me-2"></i>Search
                                </Form.Label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: isDark ? '#252d3d' : '#f9fafb', border: `1px solid ${borderCol}`, borderRadius: 8, padding: '8px 12px' }}>
                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={textMuted} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
                                    </svg>
                                    <input value={searchTerm} onChange={e => handleSearchChange(e.target.value)} placeholder="Search by indent no. or material…"
                                        style={{ border: 'none', background: 'transparent', flex: 1, outline: 'none', color: textMain, fontSize: 13, fontFamily: 'inherit' }} />
                                    {searchTerm && <button onClick={() => handleSearchChange('')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: textMuted, fontSize: 18, lineHeight: 1, padding: 0 }}>×</button>}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Status chips */}
                    {!loading && (
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
                            {chips.map(({ key, label }) => {
                                const cfg = STATUS_CONFIG[key] || {};
                                const active = statusFilter === key;
                                const c = cfg.color || '#6366f1';
                                return (
                                    <button key={key} onClick={() => handleStatusChange(key)} style={{
                                        border: `1.5px solid ${active ? (isDark ? hexA(c, 0.6) : (cfg.border || '#a5b4fc')) : borderCol}`,
                                        background: active
                                            ? (isDark ? hexA(c, 0.18) : `linear-gradient(135deg, ${cfg.bg || '#eef2ff'}, #ffffff)`)
                                            : cardBg,
                                        color: active ? c : textMuted,
                                        boxShadow: active ? `0 3px 10px ${hexA(c, 0.18)}` : 'none',
                                        borderRadius: 20, padding: '5px 14px', fontSize: 12, fontWeight: 700, cursor: 'pointer', transition: 'all .15s', fontFamily: 'inherit',
                                    }}>
                                        {label} ({key === 'ALL' ? allCount : countFor(key)})
                                    </button>
                                );
                            })}
                        </div>
                    )}

                    {error && <div style={{ background: '#e4e2fe', border: '1px solid #a5a6fc', borderRadius: 9, padding: '11px 15px', marginBottom: 14, color: '#262fdc', fontSize: 13 }}>{error}</div>}

                    {/* Loading skeleton */}
                    {loading && (
                        <>
                            <style>{`@keyframes shimmer{0%,100%{opacity:1}50%{opacity:.4}}`}</style>
                            {[1, 2, 3].map(i => (
                                <div key={i} style={{ background: cardBg, border: `1px solid ${borderCol}`, borderLeft: '4px solid #c7d2fe', borderRadius: 12, padding: '16px 18px', marginBottom: 14, animation: 'shimmer 1.5s ease-in-out infinite' }}>
                                    <div style={{ height: 14, width: '32%', background: isDark ? '#2d3748' : '#e5e7eb', borderRadius: 5, marginBottom: 10 }} />
                                    <div style={{ height: 11, width: '20%', background: isDark ? '#2d3748' : '#e5e7eb', borderRadius: 5 }} />
                                </div>
                            ))}
                        </>
                    )}

                    {/* Empty state */}
                    {!loading && !error && stockRequests.length === 0 && (
                        <div style={{ background: cardBg, border: `1px solid ${borderCol}`, borderRadius: 12, padding: '52px 20px', textAlign: 'center' }}>
                            <div style={{ fontSize: 36, marginBottom: 10 }}>📦</div>
                            <div style={{ fontWeight: 800, fontSize: 15, color: textMain, marginBottom: 5 }}>{searchTerm ? 'No records found' : 'No stock requests found'}</div>
                            <div style={{ color: textMuted, fontSize: 13 }}>
                                {searchTerm ? `No results for "${searchTerm}". Try a different indent number or material name.`
                                    : statusFilter !== 'ALL' ? 'Try adjusting your filters'
                                        : selectedOutlet?.value ? 'This outlet has no stock requests for the selected date range'
                                            : 'Stock requisitions will appear here once raised'}
                            </div>
                        </div>
                    )}

                    {!loading && stockRequests.map(req => (
                        <RequestCard key={req._id} req={req} isDark={isDark} onUpdate={setUpdateTarget} onFulfil={setFulfilTarget} />
                    ))}

                    {!loading && stockRequests.length > 0 && totalPages > 1 && (
                        <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} isDark={isDark} />
                    )}

                    {!loading && stockRequests.length > 0 && (
                        <div style={{ textAlign: 'center', color: textMuted, fontSize: 12, marginTop: 16, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <span>Showing {(currentPage - 1) * PAGE_SIZE + 1} - {Math.min(currentPage * PAGE_SIZE, totalRecords)} of {totalRecords} request{totalRecords !== 1 ? 's' : ''}</span>
                            <span style={{ color: borderCol }}>•</span>
                            <span>Page {currentPage} of {totalPages}</span>
                        </div>
                    )}
                </Container>
            </div>
        </React.Fragment>
    );
};

export default StockFlow;
